import { useState, useMemo, useCallback, useEffect } from "react";

// 1. DATA SOURCE
const RAW_DATA = [
  {
    "company": "AQR",
    "category": "Commodities Broad Basket",
    "ticker": "ARCIX",
    "name": "AQR Risk-Balanced Commodities Strategy Fund Class I",
    "pct": 9.225,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Commodities Broad Basket",
    "ticker": "ARCNX",
    "name": "AQR Risk-Balanced Commodities Strategy Fund Class N",
    "pct": 9.225,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Commodities Broad Basket",
    "ticker": "QRCRX",
    "name": "AQR Risk-Balanced Commodities Strategy Fund Class R6",
    "pct": 9.225,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Equity Market Neutral",
    "ticker": "QMNIX",
    "name": "AQR Equity Market Neutral Fund Class I",
    "pct": 45.52,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Equity Market Neutral",
    "ticker": "QMNNX",
    "name": "AQR Equity Market Neutral Fund Class N",
    "pct": 45.52,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Equity Market Neutral",
    "ticker": "QMNRX",
    "name": "AQR Equity Market Neutral Fund Class R6",
    "pct": 45.52,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Long-Short Equity",
    "ticker": "QLEIX",
    "name": "AQR Long-Short Equity Fund Class I",
    "pct": 48.96,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Long-Short Equity",
    "ticker": "QLENX",
    "name": "AQR Long-Short Equity Fund Class N",
    "pct": 48.96,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Long-Short Equity",
    "ticker": "QLERX",
    "name": "AQR Long-Short Equity Fund Class R6",
    "pct": 48.96,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Macro Trading",
    "ticker": "QGMIX",
    "name": "AQR Macro Opportunities Fund Class I",
    "pct": 57.861,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Macro Trading",
    "ticker": "QGMNX",
    "name": "AQR Macro Opportunities Fund Class N",
    "pct": 57.861,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Macro Trading",
    "ticker": "QGMRX",
    "name": "AQR Macro Opportunities Fund Class R6",
    "pct": 57.861,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Multi-Asset Leveraged",
    "ticker": "QCFIX",
    "name": "AQR CVX Fusion Fund Class I",
    "pct": 11.806,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Multi-Asset Leveraged",
    "ticker": "QCFNX",
    "name": "AQR CVX Fusion Fund Class N",
    "pct": 11.806,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Multi-Asset Leveraged",
    "ticker": "QCFRX",
    "name": "AQR CVX Fusion Fund Class R6",
    "pct": 11.806,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Multi-Asset Leveraged",
    "ticker": "QNZIX",
    "name": "AQR Trend Total Return Fund Class I",
    "pct": 13.774,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Multi-Asset Leveraged",
    "ticker": "QNZNX",
    "name": "AQR Trend Total Return Fund Class N",
    "pct": 13.774,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Multi-Asset Leveraged",
    "ticker": "QNZRX",
    "name": "AQR Trend Total Return Fund Class R6",
    "pct": 13.774,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Multi-Asset Leveraged",
    "ticker": "QMFIX",
    "name": "AQR MS Fusion Fund Class I",
    "pct": 67.859,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Multi-Asset Leveraged",
    "ticker": "QMFNX",
    "name": "AQR MS Fusion Fund Class N",
    "pct": 67.859,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Multi-Asset Leveraged",
    "ticker": "QMFRX",
    "name": "AQR MS Fusion Fund Class R6",
    "pct": 67.859,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Multi-Asset Leveraged",
    "ticker": "QLFIX",
    "name": "AQR LSE Fusion Fund Class I",
    "pct": 100,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Multi-Asset Leveraged",
    "ticker": "QLFNX",
    "name": "AQR LSE Fusion Fund Class N",
    "pct": 100,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Multi-Asset Leveraged",
    "ticker": "QLFRX",
    "name": "AQR LSE Fusion Fund Class R6",
    "pct": 100,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Multistrategy",
    "ticker": "QRPIX",
    "name": "AQR Alternative Risk Premia Fund Class I",
    "pct": 9.481,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Multistrategy",
    "ticker": "QRPNX",
    "name": "AQR Alternative Risk Premia Fund Class N",
    "pct": 9.481,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Multistrategy",
    "ticker": "QRPRX",
    "name": "AQR Alternative Risk Premia Fund Class R6",
    "pct": 9.481,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Multistrategy",
    "ticker": "QSPIX",
    "name": "AQR Style Premia Alternative Fund Class I",
    "pct": 27.206,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Multistrategy",
    "ticker": "QSPNX",
    "name": "AQR Style Premia Alternative Fund Class N",
    "pct": 27.206,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Multistrategy",
    "ticker": "QSPRX",
    "name": "AQR Style Premia Alternative Fund Class R6",
    "pct": 27.206,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Multistrategy",
    "ticker": "QDSIX",
    "name": "AQR Diversifying Strategies Fund Class I",
    "pct": 38.336,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Multistrategy",
    "ticker": "QDSNX",
    "name": "AQR Diversifying Strategies Fund Class N",
    "pct": 38.336,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Multistrategy",
    "ticker": "QDSRX",
    "name": "AQR Diversifying Strategies Fund Class R6",
    "pct": 38.336,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Relative Value Arbitrage",
    "ticker": "ADAIX",
    "name": "AQR Diversified Arbitrage Fund Class I",
    "pct": 61.982,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Relative Value Arbitrage",
    "ticker": "ADANX",
    "name": "AQR Diversified Arbitrage Fund Class N",
    "pct": 61.982,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Relative Value Arbitrage",
    "ticker": "QDARX",
    "name": "AQR Diversified Arbitrage Fund Class R6",
    "pct": 61.982,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Systematic Trend",
    "ticker": "QMHIX",
    "name": "AQR Managed Futures Strategy HV Fund Class I",
    "pct": 61.19,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Systematic Trend",
    "ticker": "QMHNX",
    "name": "AQR Managed Futures Strategy HV Fund Class N",
    "pct": 61.19,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Systematic Trend",
    "ticker": "QMHRX",
    "name": "AQR Managed Futures Strategy HV Fund Class R6",
    "pct": 61.19,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Systematic Trend",
    "ticker": "AQMIX",
    "name": "AQR Managed Futures Fund Class I",
    "pct": 78.704,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Systematic Trend",
    "ticker": "AQMNX",
    "name": "AQR Managed Futures Fund Class N",
    "pct": 78.704,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Systematic Trend",
    "ticker": "AQMRX",
    "name": "AQR Managed Futures Fund Class R6",
    "pct": 78.704,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Tactical Allocation",
    "ticker": "AQRIX",
    "name": "AQR Multi-Asset Fund Class I",
    "pct": 26.273,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Tactical Allocation",
    "ticker": "AQRNX",
    "name": "AQR Multi-Asset Fund Class N",
    "pct": 26.273,
    "threshold": false
  },
  {
    "company": "AQR",
    "category": "Tactical Allocation",
    "ticker": "AQRRX",
    "name": "AQR Multi-Asset Fund Class R6",
    "pct": 26.273,
    "threshold": false
  },
  {
    "company": "Avantis",
    "category": "Intermediate Core Bond",
    "ticker": "AVBNX",
    "name": "Avantis Core Fixed Income Fund G Class",
    "pct": 32.35,
    "threshold": false
  },
  {
    "company": "Avantis",
    "category": "Intermediate Core Bond",
    "ticker": "AVIGX",
    "name": "Avantis Core Fixed Income Fund Institutional Class",
    "pct": 32.35,
    "threshold": false
  },
  {
    "company": "Avantis",
    "category": "Moderate Allocation",
    "ticker": "AVMA",
    "name": "Avantis Moderate Allocation ETF",
    "pct": 13.94,
    "threshold": false
  },
  {
    "company": "Avantis",
    "category": "Multistrategy",
    "ticker": "AVIG",
    "name": "Avantis Core Fixed Income ETF",
    "pct": 32.04,
    "threshold": false
  },
  {
    "company": "Avantis",
    "category": "Short-Term Bond",
    "ticker": "AVSF",
    "name": "Avantis Short-Term Fixed Income ETF",
    "pct": 18.33,
    "threshold": false
  },
  {
    "company": "Avantis",
    "category": "Short-Term Bond",
    "ticker": "AVGNX",
    "name": "Avantis Short-Term Fixed Income Fund",
    "pct": 18.85,
    "threshold": false
  },
  {
    "company": "Avantis",
    "category": "Short-Term Bond",
    "ticker": "AVSFX",
    "name": "Avantis Short-Term Fixed Income Fund",
    "pct": 18.85,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Commodities Broad Basket",
    "ticker": "BCSKX",
    "name": "BlackRock Commodity Strategies Fund",
    "pct": 45.74,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Commodities Broad Basket",
    "ticker": "BICSX",
    "name": "BlackRock Commodity Strategies Fund",
    "pct": 45.74,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Commodities Broad Basket",
    "ticker": "BCSAX",
    "name": "BlackRock Commodity Strategies Fund",
    "pct": 45.74,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Commodities Broad Basket",
    "ticker": "BCSCX",
    "name": "BlackRock Commodity Strategies Fund",
    "pct": 45.74,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Commodities Broad Basket",
    "ticker": "BERYX",
    "name": "iShares Enhanced Roll Yield Index Fund",
    "pct": 23.43,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Conservative Allocation",
    "ticker": "BKCPX",
    "name": "BlackRock 20/80 Target Allocation Fund",
    "pct": 23.92,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Conservative Allocation",
    "ticker": "BRCPX",
    "name": "BlackRock 20/80 Target Allocation Fund",
    "pct": 23.92,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Conservative Allocation",
    "ticker": "BICPX",
    "name": "BlackRock 20/80 Target Allocation Fund",
    "pct": 23.92,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Conservative Allocation",
    "ticker": "BACPX",
    "name": "BlackRock 20/80 Target Allocation Fund",
    "pct": 23.92,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Conservative Allocation",
    "ticker": "BCCPX",
    "name": "BlackRock 20/80 Target Allocation Fund",
    "pct": 23.92,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Equity Market Neutral",
    "ticker": "BGCKX",
    "name": "BlackRock Global Equity Market Neutral Fund",
    "pct": 33.26,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Equity Market Neutral",
    "ticker": "BDMIX",
    "name": "BlackRock Global Equity Market Neutral Fund",
    "pct": 33.26,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Equity Market Neutral",
    "ticker": "BDMAX",
    "name": "BlackRock Global Equity Market Neutral Fund",
    "pct": 33.26,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Equity Market Neutral",
    "ticker": "BDMCX",
    "name": "BlackRock Global Equity Market Neutral Fund",
    "pct": 33.26,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Global Large-Stock Blend",
    "ticker": "BIEEX",
    "name": "BlackRock GA Dynamic Equity Fund",
    "pct": 28.83,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Global Large-Stock Blend",
    "ticker": "BGEEX",
    "name": "BlackRock GA Dynamic Equity Fund",
    "pct": 28.83,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Inflation-Protected Bond",
    "ticker": "BPRAX",
    "name": "BlackRock Inflation Protected Bond Portfolio",
    "pct": 89.63,
    "threshold": true
  },
  {
    "company": "Blackrock",
    "category": "Inflation-Protected Bond",
    "ticker": "BPRIX",
    "name": "BlackRock Inflation Protected Bond Portfolio",
    "pct": 89.63,
    "threshold": true
  },
  {
    "company": "Blackrock",
    "category": "Inflation-Protected Bond",
    "ticker": "BPRCX",
    "name": "BlackRock Inflation Protected Bond Portfolio",
    "pct": 89.63,
    "threshold": true
  },
  {
    "company": "Blackrock",
    "category": "Inflation-Protected Bond",
    "ticker": "BPLBX",
    "name": "BlackRock Inflation Protected Bond Portfolio",
    "pct": 89.63,
    "threshold": true
  },
  {
    "company": "Blackrock",
    "category": "Intermediate Core Bond",
    "ticker": "WFBIX",
    "name": "iShares U.S. Aggregate Bond Index Fund",
    "pct": 42.48,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Intermediate Core Bond",
    "ticker": "BMOIX",
    "name": "iShares U.S. Aggregate Bond Index Fund",
    "pct": 42.48,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Intermediate Core Bond",
    "ticker": "BMOAX",
    "name": "iShares U.S. Aggregate Bond Index Fund",
    "pct": 42.48,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Intermediate Core Bond",
    "ticker": "BMOPX",
    "name": "iShares U.S. Aggregate Bond Index Fund",
    "pct": 42.48,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Intermediate Core Bond",
    "ticker": "CCBBX",
    "name": "BlackRock Core Bond Portfolio",
    "pct": 21.07,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Intermediate Core Bond",
    "ticker": "BCBRX",
    "name": "BlackRock Core Bond Portfolio",
    "pct": 21.07,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Intermediate Core Bond",
    "ticker": "BFMCX",
    "name": "BlackRock Core Bond Portfolio",
    "pct": 21.07,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Intermediate Core Bond",
    "ticker": "BCBAX",
    "name": "BlackRock Core Bond Portfolio",
    "pct": 21.07,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Intermediate Core Bond",
    "ticker": "BCBCX",
    "name": "BlackRock Core Bond Portfolio",
    "pct": 21.07,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "BDVFX",
    "name": "BlackRock Diversified Fixed Income Fund",
    "pct": 22.25,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "BDVIX",
    "name": "BlackRock Diversified Fixed Income Fund",
    "pct": 22.25,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Intermediate Government",
    "ticker": "BIGBX",
    "name": "iShares U.S. Intermediate Government Bond Index Fund",
    "pct": 97.06,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Long Government",
    "ticker": "BLGBX",
    "name": "iShares U.S. Long Government Bond Index Fund",
    "pct": 98.27,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Long-Short Equity",
    "ticker": "BKLSX",
    "name": "BlackRock U.S. Insights Long/Short Equity Fund",
    "pct": 24.93,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Long-Short Equity",
    "ticker": "BILSX",
    "name": "BlackRock U.S. Insights Long/Short Equity Fund",
    "pct": 24.93,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Long-Short Equity",
    "ticker": "BALSX",
    "name": "BlackRock U.S. Insights Long/Short Equity Fund",
    "pct": 24.93,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Miscellaneous Fixed Income",
    "ticker": "BATPX",
    "name": "BATS: Interest Rate Hedge Series",
    "pct": 26.08,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Moderately Conservative Allocation",
    "ticker": "BKMPX",
    "name": "BlackRock 40/60 Target Allocation Fund",
    "pct": 21.81,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Moderately Conservative Allocation",
    "ticker": "BRMPX",
    "name": "BlackRock 40/60 Target Allocation Fund",
    "pct": 21.81,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Moderately Conservative Allocation",
    "ticker": "BIMPX",
    "name": "BlackRock 40/60 Target Allocation Fund",
    "pct": 21.81,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Moderately Conservative Allocation",
    "ticker": "BAMPX",
    "name": "BlackRock 40/60 Target Allocation Fund",
    "pct": 21.81,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Moderately Conservative Allocation",
    "ticker": "BCMPX",
    "name": "BlackRock 40/60 Target Allocation Fund",
    "pct": 21.81,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Money Market-Taxable",
    "ticker": "MSAXX",
    "name": "BlackRock Summit Cash Reserves Fund",
    "pct": 53.87,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Money Market-Taxable",
    "ticker": "MCBXX",
    "name": "BlackRock Summit Cash Reserves Fund",
    "pct": 53.87,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Money Market-Taxable",
    "ticker": "MSIXX",
    "name": "BlackRock Summit Cash Reserves Fund",
    "pct": 53.87,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Money Market-Taxable",
    "ticker": "USDXX",
    "name": "Circle Reserve Fund",
    "pct": 37.97,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Muni California Long",
    "ticker": "MKCMX",
    "name": "BlackRock California Municipal Opportunities Fund",
    "pct": 74.64,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Muni California Long",
    "ticker": "MACMX",
    "name": "BlackRock California Municipal Opportunities Fund",
    "pct": 74.64,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Muni California Long",
    "ticker": "MDCMX",
    "name": "BlackRock California Municipal Opportunities Fund",
    "pct": 74.64,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Muni California Long",
    "ticker": "MECMX",
    "name": "BlackRock California Municipal Opportunities Fund",
    "pct": 74.64,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Muni California Long",
    "ticker": "MFCMX",
    "name": "BlackRock California Municipal Opportunities Fund",
    "pct": 74.64,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Short-Term Inflation-Protected Bond",
    "ticker": "BAIPX",
    "name": "iShares Short-Term TIPS Bond Index Fund",
    "pct": 99.28,
    "threshold": true
  },
  {
    "company": "Blackrock",
    "category": "Short-Term Inflation-Protected Bond",
    "ticker": "BIIPX",
    "name": "iShares Short-Term TIPS Bond Index Fund",
    "pct": 99.28,
    "threshold": true
  },
  {
    "company": "Blackrock",
    "category": "Short-Term Inflation-Protected Bond",
    "ticker": "BKIPX",
    "name": "iShares Short-Term TIPS Bond Index Fund",
    "pct": 99.28,
    "threshold": true
  },
  {
    "company": "Blackrock",
    "category": "Target-Date 2030",
    "ticker": "LINKX",
    "name": "BlackRock LifePath Index 2030 Fund",
    "pct": 29.42,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Target-Date 2030",
    "ticker": "LINIX",
    "name": "BlackRock LifePath Index 2030 Fund",
    "pct": 29.42,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Target-Date 2030",
    "ticker": "LINAX",
    "name": "BlackRock LifePath Index 2030 Fund",
    "pct": 29.42,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Target-Date 2030",
    "ticker": "LIDPX",
    "name": "BlackRock LifePath Index 2030 Fund",
    "pct": 29.42,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Target-Date 2030",
    "ticker": "LENKX",
    "name": "BlackRock LifePath ESG Index 2030 Fund",
    "pct": 22.02,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Target-Date 2030",
    "ticker": "LENIX",
    "name": "BlackRock LifePath ESG Index 2030 Fund",
    "pct": 22.02,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Target-Date 2030",
    "ticker": "LENAX",
    "name": "BlackRock LifePath ESG Index 2030 Fund",
    "pct": 22.02,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Target-Date 2035",
    "ticker": "LEJKX",
    "name": "BlackRock LifePath ESG Index 2035 Fund",
    "pct": 19.95,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Target-Date 2035",
    "ticker": "LEJIX",
    "name": "BlackRock LifePath ESG Index 2035 Fund",
    "pct": 19.95,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Target-Date 2035",
    "ticker": "LEJAX",
    "name": "BlackRock LifePath ESG Index 2035 Fund",
    "pct": 19.95,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Target-Date Retirement",
    "ticker": "LIRKX",
    "name": "BlackRock LifePath Index Retirement Fund",
    "pct": 39.49,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Target-Date Retirement",
    "ticker": "LIRIX",
    "name": "BlackRock LifePath Index Retirement Fund",
    "pct": 39.49,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Target-Date Retirement",
    "ticker": "LIRAX",
    "name": "BlackRock LifePath Index Retirement Fund",
    "pct": 39.49,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Target-Date Retirement",
    "ticker": "LIRPX",
    "name": "BlackRock LifePath Index Retirement Fund",
    "pct": 39.49,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Target-Date Retirement",
    "ticker": "LERKX",
    "name": "BlackRock LifePath ESG Index Retirement Fund",
    "pct": 27.29,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Target-Date Retirement",
    "ticker": "LERIX",
    "name": "BlackRock LifePath ESG Index Retirement Fund",
    "pct": 27.29,
    "threshold": false
  },
  {
    "company": "Blackrock",
    "category": "Target-Date Retirement",
    "ticker": "LERAX",
    "name": "BlackRock LifePath ESG Index Retirement Fund",
    "pct": 27.29,
    "threshold": false
  },
  {
    "company": "Dimensional",
    "category": "Inflation-Protected Bond",
    "ticker": "DFIP",
    "name": "Dimensional Inflation-Protected Securities ETF",
    "pct": 99.87,
    "threshold": true
  },
  {
    "company": "Dimensional",
    "category": "Intermediate Core Bond",
    "ticker": "DFCF",
    "name": "Dimensional Core Fixed Income ETF",
    "pct": 40.91,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Commodities Broad Basket",
    "ticker": "FIFGX",
    "name": "Fidelity SAI Inflation-Focused Fund",
    "pct": 11.88,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Commodities Broad Basket",
    "ticker": "FYHTX",
    "name": "Fidelity Commodity Strategy Fund",
    "pct": 22.52,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Commodities Broad Basket",
    "ticker": "FCSSX",
    "name": "Fidelity Series Commodity Strategy Fund",
    "pct": 27.08,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Diversified Emerging Mkts",
    "ticker": "FFNZX",
    "name": "Fidelity SAI Emerging Markets Momentum Index Fund",
    "pct": 12.92,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Foreign Large Growth",
    "ticker": "FIIIX",
    "name": "Fidelity Advisor Investment Grade Bond Fund - Class I",
    "pct": 43.345,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Global Aggressive Allocation",
    "ticker": "FRAGX",
    "name": "85% Allocation Fund",
    "pct": 11.42,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Global Bond-USD Hedged",
    "ticker": "FCDSX",
    "name": "Fidelity Series International Credit Fund",
    "pct": 22.17,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Global Bond-USD Hedged",
    "ticker": "FGBFX",
    "name": "Fidelity Global Credit Fund",
    "pct": 22.18,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Global Bond-USD Hedged",
    "ticker": "FSNDX",
    "name": "Fidelity SAI International Credit Fund",
    "pct": 22.4,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Global Conservative Allocation",
    "ticker": "FASIX",
    "name": "Fidelity Asset Manager 20%",
    "pct": 23.2,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Global Flexible Bond - GBP Hedged",
    "ticker": "FSBD",
    "name": "Fidelity Sustainable Core Plus Bond ETF",
    "pct": 31.9,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Global Moderate Allocation",
    "ticker": "FYMRX",
    "name": "Fidelity Sustainable Multi-Asset Fund",
    "pct": 25.09,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Global Moderate Allocation",
    "ticker": "FYMAX",
    "name": "Fidelity Advisor Sustainable Multi-Asset Fund - Class A",
    "pct": 25.093,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Global Moderate Allocation",
    "ticker": "FYMCX",
    "name": "Fidelity Advisor Sustainable Multi-Asset Fund - Class C",
    "pct": 25.093,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Global Moderate Allocation",
    "ticker": "FYMIX",
    "name": "Fidelity Advisor Sustainable Multi-Asset Fund - Class I",
    "pct": 25.093,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Global Moderate Allocation",
    "ticker": "FYMMX",
    "name": "Fidelity Advisor Sustainable Multi-Asset Fund - Class M",
    "pct": 25.093,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Global Moderately Aggressive Allocation",
    "ticker": "FFNOX",
    "name": "Fidelity Multi-Asset Index Fund",
    "pct": 13.05,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Global Moderately Conservative Allocation",
    "ticker": "FFANX",
    "name": "Fidelity Asset Manager 40%",
    "pct": 16.535,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Global Moderately Conservative Allocation",
    "ticker": "FFNCX",
    "name": "Fidelity Advisor Asset Manager 40% - Class C",
    "pct": 16.535,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Global Moderately Conservative Allocation",
    "ticker": "FHLSX",
    "name": "Fidelity Health Savings Fund",
    "pct": 17.429,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Global Moderately Conservative Allocation",
    "ticker": "FCANX",
    "name": "Fidelity Advisor Asset Manager 30% - Class C",
    "pct": 20.045,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Global Moderately Conservative Allocation",
    "ticker": "FTANX",
    "name": "Fidelity Asset Manager 30%",
    "pct": 20.045,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Global Moderately Conservative Allocation",
    "ticker": "FHSNX",
    "name": "Fidelity Health Savings Index Fund",
    "pct": 28.41,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Inflation-Protected Bond",
    "ticker": "FFNYX",
    "name": "Fidelity SAI 0-5 Year Inflation-Protected Bond Index Fund",
    "pct": 95.48,
    "threshold": true
  },
  {
    "company": "Fidelity",
    "category": "Inflation-Protected Bond",
    "ticker": "FIPDX",
    "name": "Fidelity Inflation-Protected Bond Index Fund",
    "pct": 99.77,
    "threshold": true
  },
  {
    "company": "Fidelity",
    "category": "Inflation-Protected Bond",
    "ticker": "FSPWX",
    "name": "Fidelity SAI Inflation-Protected Bond Index Fund",
    "pct": 99.81,
    "threshold": true
  },
  {
    "company": "Fidelity",
    "category": "Inflation-Protected Bond",
    "ticker": "FSTDX",
    "name": "Fidelity Series 5+ Year Inflation-Protected Bond Index Fund",
    "pct": 99.94,
    "threshold": true
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core Bond",
    "ticker": "FECBX",
    "name": "Fidelity SAI Enhanced Core Bond Fund",
    "pct": 36.25,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core Bond",
    "ticker": "FTHRX",
    "name": "Fidelity Intermediate Bond Fund",
    "pct": 36.93,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core Bond",
    "ticker": "FSIGX",
    "name": "Fidelity Series Investment Grade Bond Fund",
    "pct": 41.41,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core Bond",
    "ticker": "FBNDX",
    "name": "Fidelity Investment Grade Bond Fund",
    "pct": 43.34,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core Bond",
    "ticker": "FGBAX",
    "name": "Fidelity Advisor Investment Grade Bond Fund - Class A",
    "pct": 43.345,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core Bond",
    "ticker": "FGBCX",
    "name": "Fidelity Advisor Investment Grade Bond Fund - Class C",
    "pct": 43.345,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core Bond",
    "ticker": "FGBTX",
    "name": "Fidelity Advisor Investment Grade Bond Fund - Class M",
    "pct": 43.345,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core Bond",
    "ticker": "FIKQX",
    "name": "Fidelity Advisor Investment Grade Bond Fund - Class Z",
    "pct": 43.345,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core Bond",
    "ticker": "FIFZX",
    "name": "Fidelity Series Bond Index Fund",
    "pct": 43.56,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core Bond",
    "ticker": "FXNAX",
    "name": "Fidelity U.S. Bond Index Fund",
    "pct": 43.56,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core Bond",
    "ticker": "FNDSX",
    "name": "Fidelity Sustainability Bond Index Fund",
    "pct": 44.23,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core Bond",
    "ticker": "FIGB",
    "name": "Fidelity Investment Grade Bond ETF",
    "pct": 44.28,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core Bond",
    "ticker": "FIBUX",
    "name": "Fidelity Flex U.S. Bond Index Fund",
    "pct": 44.61,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core Bond",
    "ticker": "FIGDX",
    "name": "Fidelity Series Sustainable Investment Grade Bond Fund",
    "pct": 51.26,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "FSMTX",
    "name": "Fidelity SAI Total Bond Fund",
    "pct": 28.68,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "FBKWX",
    "name": "Fidelity Advisor Total Bond Fund - Class Z",
    "pct": 29.918,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "FCEPX",
    "name": "Fidelity Advisor Total Bond Fund - Class C",
    "pct": 29.918,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "FEPAX",
    "name": "Fidelity Advisor Total Bond Fund - Class A",
    "pct": 29.918,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "FEPIX",
    "name": "Fidelity Advisor Total Bond Fund - Class I",
    "pct": 29.918,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "FEPTX",
    "name": "Fidelity Advisor Total Bond Fund - Class M",
    "pct": 29.918,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "FTBFX",
    "name": "Fidelity Total Bond Fund",
    "pct": 29.92,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "FBND",
    "name": "Fidelity Total Bond ETF",
    "pct": 30.34,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "FTKFX",
    "name": "Fidelity Total Bond K6 Fund",
    "pct": 33.56,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "FIAEX",
    "name": "Fidelity Sustainable Core Plus Bond Fund",
    "pct": 36.36,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "FIAIX",
    "name": "Fidelity Advisor Sustainable Core Plus Bond Fund - Class A",
    "pct": 36.363,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "FIAJX",
    "name": "Fidelity Advisor Sustainable Core Plus Bond Fund - Class C",
    "pct": 36.363,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "FIAKX",
    "name": "Fidelity Advisor Sustainable Core Plus Bond Fund - Class M",
    "pct": 36.363,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "FIALX",
    "name": "Fidelity Advisor Sustainable Core Plus Bond Fund - Class I",
    "pct": 36.363,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "FIAMX",
    "name": "Fidelity Advisor Sustainable Core Plus Bond Fund - Class Z",
    "pct": 36.363,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "FFEBX",
    "name": "Fidelity Environmental Bond Fund",
    "pct": 41.2,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "FEBBX",
    "name": "Fidelity Advisor Environmental Bond Fund - Class A",
    "pct": 41.201,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "FEBDX",
    "name": "Fidelity Advisor Environmental Bond Fund - Class C",
    "pct": 41.201,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "FEBEX",
    "name": "Fidelity Advisor Environmental Bond Fund - Class M",
    "pct": 41.201,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "FEBFX",
    "name": "Fidelity Advisor Environmental Bond Fund - Class I",
    "pct": 41.201,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "FEBGX",
    "name": "Fidelity Advisor Environmental Bond Fund - Class Z",
    "pct": 41.201,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "FIABX",
    "name": "Fidelity SAI Sustainable Core Plus Bond Fund",
    "pct": 44,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Government",
    "ticker": "FGOVX",
    "name": "Fidelity Government Income Fund",
    "pct": 44.85,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Government",
    "ticker": "FIKPX",
    "name": "Fidelity Advisor Government Income Fund - Class Z",
    "pct": 44.851,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Government",
    "ticker": "FVIAX",
    "name": "Fidelity Advisor Government Income Fund - Class A",
    "pct": 44.851,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Government",
    "ticker": "FVICX",
    "name": "Fidelity Advisor Government Income Fund - Class C",
    "pct": 44.851,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Government",
    "ticker": "FVIIX",
    "name": "Fidelity Advisor Government Income Fund - Class I",
    "pct": 44.851,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Government",
    "ticker": "FVITX",
    "name": "Fidelity Advisor Government Income Fund - Class M",
    "pct": 44.851,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Government",
    "ticker": "FSTGX",
    "name": "Fidelity Intermediate Government Income Fund",
    "pct": 75.43,
    "threshold": true
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Government",
    "ticker": "FHNFX",
    "name": "Fidelity Series Government Bond Index Fund",
    "pct": 99.33,
    "threshold": true
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Government",
    "ticker": "FUTBX",
    "name": "Fidelity SAI U.S. Treasury Bond Index Fund",
    "pct": 99.63,
    "threshold": true
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Government",
    "ticker": "FUAMX",
    "name": "Fidelity Intermediate Treasury Bond Index Fund",
    "pct": 99.69,
    "threshold": true
  },
  {
    "company": "Fidelity",
    "category": "Intermediate Government",
    "ticker": "FSIWX",
    "name": "Fidelity SAI Intermediate Treasury Bond Index Fund",
    "pct": 99.86,
    "threshold": true
  },
  {
    "company": "Fidelity",
    "category": "Long Government",
    "ticker": "FTLTX",
    "name": "Fidelity Series Long-Term Treasury Bond Index Fund",
    "pct": 99.68,
    "threshold": true
  },
  {
    "company": "Fidelity",
    "category": "Long Government",
    "ticker": "FNBGX",
    "name": "Fidelity Long-Term Treasury Bond Index Fund",
    "pct": 99.79,
    "threshold": true
  },
  {
    "company": "Fidelity",
    "category": "Long Government",
    "ticker": "FBLTX",
    "name": "Fidelity SAI Long-Term Treasury Bond Index Fund",
    "pct": 99.82,
    "threshold": true
  },
  {
    "company": "Fidelity",
    "category": "Moderate Allocation",
    "ticker": "FPUKX",
    "name": "Fidelity Puritan Fund - Class K",
    "pct": 26.406,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Moderate Allocation",
    "ticker": "FPURX",
    "name": "Fidelity Puritan Fund",
    "pct": 26.406,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Moderate Allocation",
    "ticker": "FPKFX",
    "name": "Fidelity Puritan K6 Fund",
    "pct": 26.69,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Moderate Allocation",
    "ticker": "FABLX",
    "name": "Fidelity Advisor Balanced Fund - Class M",
    "pct": 26.859,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Moderate Allocation",
    "ticker": "FAIGX",
    "name": "Fidelity Advisor Balanced Fund - Class A",
    "pct": 26.859,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Moderate Allocation",
    "ticker": "FBAKX",
    "name": "Fidelity Balanced Fund - Class K",
    "pct": 26.859,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Moderate Allocation",
    "ticker": "FBALX",
    "name": "Fidelity Balanced Fund",
    "pct": 26.859,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Moderate Allocation",
    "ticker": "FBARX",
    "name": "Fidelity Advisor Balanced Fund - Class C",
    "pct": 26.859,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Moderate Allocation",
    "ticker": "FBAUX",
    "name": "Fidelity Advisor Balanced Fund - Class I",
    "pct": 26.859,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Moderate Allocation",
    "ticker": "FBKFX",
    "name": "Fidelity Balanced K6 Fund",
    "pct": 27.05,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Moderate Allocation",
    "ticker": "FRYBX",
    "name": "50% Allocation Fund",
    "pct": 29.98,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Moderate Allocation",
    "ticker": "FEDUX",
    "name": "Fidelity Education Fund",
    "pct": 47.28,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Moderately Aggressive Allocation",
    "ticker": "FRGAX",
    "name": "70% Allocation Fund",
    "pct": 21.66,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Moderately Conservative Allocation",
    "ticker": "FMSDX",
    "name": "Fidelity Multi-Asset Income Fund",
    "pct": 16.86,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Moderately Conservative Allocation",
    "ticker": "FAYZX",
    "name": "Fidelity Advisor Multi-Asset Income Fund - Class I",
    "pct": 16.86,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Moderately Conservative Allocation",
    "ticker": "FCSRX",
    "name": "Fidelity Advisor Strategic Real Return Fund - Class C",
    "pct": 25.893,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Moderately Conservative Allocation",
    "ticker": "FIQDX",
    "name": "Fidelity Advisor Strategic Real Return Fund - Class Z",
    "pct": 25.893,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Moderately Conservative Allocation",
    "ticker": "FSIRX",
    "name": "Fidelity Advisor Strategic Real Return Fund - Class I",
    "pct": 25.893,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Moderately Conservative Allocation",
    "ticker": "FSRAX",
    "name": "Fidelity Advisor Strategic Real Return Fund - Class A",
    "pct": 25.893,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Moderately Conservative Allocation",
    "ticker": "FSRKX",
    "name": "Fidelity Strategic Real Return Fund - Class K6",
    "pct": 25.893,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Moderately Conservative Allocation",
    "ticker": "FSRRX",
    "name": "Fidelity Strategic Real Return Fund",
    "pct": 25.893,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Moderately Conservative Allocation",
    "ticker": "FSRTX",
    "name": "Fidelity Advisor Strategic Real Return Fund - Class M",
    "pct": 25.893,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Moderately Conservative Allocation",
    "ticker": "FMWIX",
    "name": "30% Allocation Fund",
    "pct": 38.56,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Money Market-Taxable",
    "ticker": "FCGXX",
    "name": "Fidelity Investments Money Market Government Portfolio - Class III",
    "pct": 50.107,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Money Market-Taxable",
    "ticker": "FCVXX",
    "name": "Fidelity Investments Money Market Government Portfolio - Class II",
    "pct": 50.107,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Money Market-Taxable",
    "ticker": "FGEXX",
    "name": "Fidelity Investments Money Market Government Portfolio - Select Class",
    "pct": 50.107,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Money Market-Taxable",
    "ticker": "FIGXX",
    "name": "Fidelity Investments Money Market Government Portfolio - Class I",
    "pct": 50.107,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Money Market-Taxable",
    "ticker": "FRGXX",
    "name": "Fidelity Investments Money Market Government Portfolio - Institutional Class",
    "pct": 50.107,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Money Market-Taxable",
    "ticker": "FNBXX",
    "name": "Fidelity Government Money Market Fund - Class K6",
    "pct": 50.9,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Money Market-Taxable",
    "ticker": "FZAXX",
    "name": "Fidelity Government Money Market Fund - Capital Reserves Class",
    "pct": 50.9,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Money Market-Taxable",
    "ticker": "FZBXX",
    "name": "Fidelity Government Money Market Fund - Daily Money Class",
    "pct": 50.9,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Money Market-Taxable",
    "ticker": "FZCXX",
    "name": "Fidelity Government Money Market Fund - Premium Class",
    "pct": 50.9,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Money Market-Taxable",
    "ticker": "FZGXX",
    "name": "Fidelity Government Money Market Fund - Class M",
    "pct": 50.9,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Money Market-Taxable",
    "ticker": "FZSXX",
    "name": "Fidelity Government Money Market Fund - Class S",
    "pct": 50.9,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Money Market-Taxable",
    "ticker": "SPAXX",
    "name": "Fidelity Government Money Market Fund",
    "pct": 50.9,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Money Market-Taxable",
    "ticker": "FGNXX",
    "name": "Fidelity Series Government Money Market Fund",
    "pct": 51.04,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Money Market-Taxable",
    "ticker": "FDRXX",
    "name": "Fidelity Government Cash Reserves",
    "pct": 52.17,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Money Market-Taxable",
    "ticker": "FLGXX",
    "name": "Fidelity FlexSM Government Money Market Fund",
    "pct": 56.77,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Money Market-Taxable",
    "ticker": "FCEXX",
    "name": "Fidelity Investments Money Market Treasury Portfolio - Class II",
    "pct": 60.53,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Money Market-Taxable",
    "ticker": "FCSXX",
    "name": "Fidelity Investments Money Market Treasury Portfolio - Class III",
    "pct": 60.53,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Money Market-Taxable",
    "ticker": "FISXX",
    "name": "Fidelity Investments Money Market Treasury Portfolio - Class I",
    "pct": 60.53,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Money Market-Taxable",
    "ticker": "FRBXX",
    "name": "Fidelity Investments Money Market Treasury Portfolio - Institutional Class",
    "pct": 60.53,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Money Market-Taxable",
    "ticker": "FTUXX",
    "name": "Fidelity Investments Money Market Treasury Portfolio - Select Class",
    "pct": 60.53,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Money Market-Taxable",
    "ticker": "FTVXX",
    "name": "Fidelity Investments Money Market Treasury Portfolio - Class IV",
    "pct": 60.53,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Money Market-Taxable",
    "ticker": "FDCXX",
    "name": "Fidelity Treasury Money Market Fund - Advisor Class C",
    "pct": 61.521,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Money Market-Taxable",
    "ticker": "FDUXX",
    "name": "Fidelity Treasury Money Market Fund - Daily Money Class",
    "pct": 61.521,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Money Market-Taxable",
    "ticker": "FSRXX",
    "name": "Fidelity Treasury Money Market Fund - Capital Reserves Class",
    "pct": 61.521,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Money Market-Taxable",
    "ticker": "FZFXX",
    "name": "Fidelity Treasury Money Market Fund",
    "pct": 61.521,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Money Market-Taxable",
    "ticker": "FDLXX",
    "name": "Fidelity Treasury Only Money Market Fund",
    "pct": 98.671,
    "threshold": true
  },
  {
    "company": "Fidelity",
    "category": "Money Market-Taxable",
    "ticker": "FYIXX",
    "name": "Fidelity Treasury Only Money Market Fund - Class OUS",
    "pct": 98.671,
    "threshold": true
  },
  {
    "company": "Fidelity",
    "category": "Money Market-Taxable",
    "ticker": "FOIXX",
    "name": "Fidelity Investments Money Market Treasury Only Portfolio - Class III",
    "pct": 99.591,
    "threshold": true
  },
  {
    "company": "Fidelity",
    "category": "Money Market-Taxable",
    "ticker": "FOPXX",
    "name": "Fidelity Investments Money Market Treasury Only Portfolio - Class IV",
    "pct": 99.591,
    "threshold": true
  },
  {
    "company": "Fidelity",
    "category": "Money Market-Taxable",
    "ticker": "FOXXX",
    "name": "Fidelity Investments Money Market Treasury Only Portfolio - Class II",
    "pct": 99.591,
    "threshold": true
  },
  {
    "company": "Fidelity",
    "category": "Money Market-Taxable",
    "ticker": "FRSXX",
    "name": "Fidelity Investments Money Market Treasury Only Portfolio - Institutional Clas",
    "pct": 99.591,
    "threshold": true
  },
  {
    "company": "Fidelity",
    "category": "Money Market-Taxable",
    "ticker": "FSIXX",
    "name": "Fidelity Investments Money Market Treasury Only Portfolio - Class I",
    "pct": 99.591,
    "threshold": true
  },
  {
    "company": "Fidelity",
    "category": "Money Market-Taxable",
    "ticker": "FTYXX",
    "name": "Fidelity Investments Money Market Treasury Only Portfolio - Select Class",
    "pct": 99.591,
    "threshold": true
  },
  {
    "company": "Fidelity",
    "category": "Money Market-Taxable",
    "ticker": "FYHXX",
    "name": "Fidelity Treasury Digital Fund - Liquidity",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "Fidelity",
    "category": "Money Market-Taxable",
    "ticker": "FYOXX",
    "name": "Fidelity Treasury Digital Fund - OnChain Class",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "Fidelity",
    "category": "Multisector Bond",
    "ticker": "FSRCX",
    "name": "Fidelity Advisor Strategic Income Fund - Class C",
    "pct": 16.509,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Multisector Bond",
    "ticker": "FSRIX",
    "name": "Fidelity Advisor Strategic Income Fund - Class I",
    "pct": 16.509,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Multisector Bond",
    "ticker": "FSTAX",
    "name": "Fidelity Advisor Strategic Income Fund - Class A",
    "pct": 16.509,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Multisector Bond",
    "ticker": "FADMX",
    "name": "Fidelity Strategic Income Fund",
    "pct": 16.51,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Multisector Bond",
    "ticker": "FTBD",
    "name": "Fidelity Tactical Bond ETF",
    "pct": 36.41,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Multisector Bond",
    "ticker": "FBAHX",
    "name": "Fidelity Advisor Tactical Bond Fund - Class I",
    "pct": 39.057,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Multisector Bond",
    "ticker": "FBAPX",
    "name": "Fidelity Advisor Tactical Bond Fund - Class Z",
    "pct": 39.057,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Multisector Bond",
    "ticker": "FTKAX",
    "name": "Fidelity Advisor Tactical Bond Fund - Class A",
    "pct": 39.057,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Multisector Bond",
    "ticker": "FTKCX",
    "name": "Fidelity Advisor Tactical Bond Fund - Class C",
    "pct": 39.057,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Multisector Bond",
    "ticker": "FTYMX",
    "name": "Fidelity Advisor Tactical Bond Fund - Class M",
    "pct": 39.057,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Multisector Bond",
    "ticker": "FBAGX",
    "name": "Fidelity Tactical Bond Fund",
    "pct": 39.06,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Multistrategy",
    "ticker": "FRPDX",
    "name": "Fidelity SAI Alternative Risk Premia Commodity Strategy Fund",
    "pct": 63.76,
    "threshold": true
  },
  {
    "company": "Fidelity",
    "category": "Prime Money Market",
    "ticker": "FZDXX",
    "name": "Fidelity Money Market Fund - Premium Class",
    "pct": 14.56,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Prime Money Market",
    "ticker": "SPRXX",
    "name": "Fidelity Money Market Fund",
    "pct": 14.56,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Prime Money Market",
    "ticker": "FCOXX",
    "name": "Fidelity Investments Money Market - Money Market Portfolio - Class III",
    "pct": 16.165,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Prime Money Market",
    "ticker": "FMPXX",
    "name": "Fidelity Investments Money Market - Money Market Portfolio - Class I",
    "pct": 16.165,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Prime Money Market",
    "ticker": "FMYXX",
    "name": "Fidelity Investments Money Market - Money Market Portfolio - Select Class",
    "pct": 16.165,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Prime Money Market",
    "ticker": "FNSXX",
    "name": "Fidelity Investments Money Market - Money Market Portfolio - Institutional Cla",
    "pct": 16.165,
    "threshold": true
  },
  {
    "company": "Fidelity",
    "category": "Relative Value Arbitrage",
    "ticker": "FSAWX",
    "name": "Fidelity SAI Convertible Arbitrage Fund",
    "pct": 10.04,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Short Government",
    "ticker": "FFXSX",
    "name": "Fidelity Limited Term Government Fund",
    "pct": 74.56,
    "threshold": true
  },
  {
    "company": "Fidelity",
    "category": "Short Government",
    "ticker": "FSSWX",
    "name": "Fidelity SAI Short-Term Treasury Bond Index Fund",
    "pct": 98.77,
    "threshold": true
  },
  {
    "company": "Fidelity",
    "category": "Short Government",
    "ticker": "FUMBX",
    "name": "Fidelity Short-Term Treasury Bond Index Fund",
    "pct": 99.57,
    "threshold": true
  },
  {
    "company": "Fidelity",
    "category": "Short-Term Bond",
    "ticker": "FLTB",
    "name": "Fidelity Limited Term Bond ETF",
    "pct": 12.51,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Short-Term Bond",
    "ticker": "FJRLX",
    "name": "Fidelity Limited Term Bond Fund",
    "pct": 15.17,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Short-Term Bond",
    "ticker": "FSHBX",
    "name": "Fidelity Short-Term Bond Fund",
    "pct": 31.69,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Short-Term Bond",
    "ticker": "FANCX",
    "name": "Fidelity Advisor Short-Term Bond Fund - Class C",
    "pct": 31.693,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Short-Term Bond",
    "ticker": "FBNAX",
    "name": "Fidelity Advisor Short-Term Bond Fund - Class A",
    "pct": 31.693,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Short-Term Bond",
    "ticker": "FBNIX",
    "name": "Fidelity Advisor Short-Term Bond Fund - Class I",
    "pct": 31.693,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Short-Term Bond",
    "ticker": "FBNTX",
    "name": "Fidelity Advisor Short-Term Bond Fund - Class M",
    "pct": 31.693,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Short-Term Bond",
    "ticker": "FIKTX",
    "name": "Fidelity Advisor Short-Term Bond Fund - Class Z",
    "pct": 31.693,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Short-Term Bond",
    "ticker": "FZOMX",
    "name": "Fidelity SAI Short-Term Bond Fund",
    "pct": 32.76,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Short-Term Bond",
    "ticker": "FNSOX",
    "name": "Fidelity Short-Term Bond Index Fund",
    "pct": 62.31,
    "threshold": true
  },
  {
    "company": "Fidelity",
    "category": "Short-Term Inflation-Protected Bond",
    "ticker": "FSTZX",
    "name": "Fidelity Series 0-5 Year Inflation-Protected Bond Index Fund",
    "pct": 98.85,
    "threshold": true
  },
  {
    "company": "Fidelity",
    "category": "Systematic Trend",
    "ticker": "FMFLX",
    "name": "Fidelity SAI Managed Futures Fund",
    "pct": 33.7,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Systematic Trend",
    "ticker": "FFUT",
    "name": "Fidelity Managed Futures ETF",
    "pct": 35.27,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Tactical Allocation",
    "ticker": "FAPSX",
    "name": "Fidelity Risk Parity Fund",
    "pct": 20.64,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Tactical Allocation",
    "ticker": "FAPUX",
    "name": "Fidelity Advisor Risk Parity Fund - Class A",
    "pct": 20.641,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Tactical Allocation",
    "ticker": "FAPVX",
    "name": "Fidelity Advisor Risk Parity Fund - Class C",
    "pct": 20.641,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Tactical Allocation",
    "ticker": "FAPWX",
    "name": "Fidelity Advisor Risk Parity Fund - Class M",
    "pct": 20.641,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Tactical Allocation",
    "ticker": "FAPYX",
    "name": "Fidelity Advisor Risk Parity Fund - Class I",
    "pct": 20.641,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Tactical Allocation",
    "ticker": "FAPZX",
    "name": "Fidelity Advisor Risk Parity Fund - Class Z",
    "pct": 20.641,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2000-2010",
    "ticker": "FACFX",
    "name": "Fidelity Advisor Freedom 2010 Fund - Class A",
    "pct": 30.187,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2000-2010",
    "ticker": "FCIFX",
    "name": "Fidelity Advisor Freedom 2010 Fund - Class I",
    "pct": 30.187,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2000-2010",
    "ticker": "FIJJX",
    "name": "Fidelity Advisor Freedom 2010 Fund - Class Z",
    "pct": 30.187,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2000-2010",
    "ticker": "FUGLX",
    "name": "Fidelity Advisor Freedom 2010 Fund - Class K6",
    "pct": 30.187,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2000-2010",
    "ticker": "FFFCX",
    "name": "Fidelity Freedom 2010 Fund",
    "pct": 31.615,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2000-2010",
    "ticker": "FOTKX",
    "name": "Fidelity Freedom 2010 Fund - Class K6",
    "pct": 31.615,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2000-2010",
    "ticker": "FFBHX",
    "name": "Fidelity Freedom Blend 2010 Fund - Premier Class",
    "pct": 38.678,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2000-2010",
    "ticker": "FHAYX",
    "name": "Fidelity Freedom Blend 2010 Fund",
    "pct": 38.678,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2000-2010",
    "ticker": "FHPDX",
    "name": "Fidelity Freedom Blend 2010 Fund - Class K6",
    "pct": 38.678,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2000-2010",
    "ticker": "FISNX",
    "name": "Fidelity Flex Freedom Blend 2010 Fund",
    "pct": 39.8,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2000-2010",
    "ticker": "FIRQX",
    "name": "Fidelity Managed Retirement 2010 Fund",
    "pct": 43.195,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2000-2010",
    "ticker": "FRQKX",
    "name": "Fidelity Managed Retirement 2010 Fund - Class K",
    "pct": 43.195,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2000-2010",
    "ticker": "FIRRX",
    "name": "Fidelity Simplicity RMD 2010 Fund",
    "pct": 47.15,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2000-2010",
    "ticker": "FATUX",
    "name": "Fidelity Freedom Index 2010 Fund - Premier II Class",
    "pct": 54.086,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2000-2010",
    "ticker": "FCYPX",
    "name": "Fidelity Freedom Index 2010 Fund - Premier Class",
    "pct": 54.086,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2000-2010",
    "ticker": "FFWTX",
    "name": "Fidelity Freedom Index 2010 Fund - Institutional Premium Class",
    "pct": 54.086,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2000-2010",
    "ticker": "FKIFX",
    "name": "Fidelity Freedom Index 2010 Fund - Investor Class",
    "pct": 54.086,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2000-2010",
    "ticker": "FSUYX",
    "name": "Fidelity Sustainable Target Date 2010 Fund",
    "pct": 55.139,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2000-2010",
    "ticker": "FSUZX",
    "name": "Fidelity Advisor Sustainable Target Date 2010 Fund - Class A",
    "pct": 55.139,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2000-2010",
    "ticker": "FSVCX",
    "name": "Fidelity Advisor Sustainable Target Date 2010 Fund - Class C",
    "pct": 55.139,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2000-2010",
    "ticker": "FSVGX",
    "name": "Fidelity Advisor Sustainable Target Date 2010 Fund - Class I",
    "pct": 55.139,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2000-2010",
    "ticker": "FSVHX",
    "name": "Fidelity Advisor Sustainable Target Date 2010 Fund - Class Z",
    "pct": 55.139,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2000-2010",
    "ticker": "FSVMX",
    "name": "Fidelity Sustainable Target Date 2010 Fund - Class K6",
    "pct": 55.139,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2015",
    "ticker": "FFVAX",
    "name": "Fidelity Advisor Freedom 2015 Fund - Class A",
    "pct": 24.714,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2015",
    "ticker": "FFVCX",
    "name": "Fidelity Advisor Freedom 2015 Fund - Class C",
    "pct": 24.714,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2015",
    "ticker": "FFVIX",
    "name": "Fidelity Advisor Freedom 2015 Fund - Class I",
    "pct": 24.714,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2015",
    "ticker": "FIJKX",
    "name": "Fidelity Advisor Freedom 2015 Fund - Class Z",
    "pct": 24.714,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2015",
    "ticker": "FFVFX",
    "name": "Fidelity Freedom 2015 Fund",
    "pct": 26.111,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2015",
    "ticker": "FPTKX",
    "name": "Fidelity Freedom 2015 Fund - Class K6",
    "pct": 26.111,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2015",
    "ticker": "FFBJX",
    "name": "Fidelity Freedom Blend 2015 Fund - Premier Class",
    "pct": 32.822,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2015",
    "ticker": "FHAWX",
    "name": "Fidelity Freedom Blend 2015 Fund",
    "pct": 32.822,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2015",
    "ticker": "FJAQX",
    "name": "Fidelity Advisor Freedom Blend 2015 Fund - Class I",
    "pct": 32.822,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2015",
    "ticker": "FJASX",
    "name": "Fidelity Advisor Freedom Blend 2015 Fund - Class C",
    "pct": 32.822,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2015",
    "ticker": "FJATX",
    "name": "Fidelity Advisor Freedom Blend 2015 Fund - Class M",
    "pct": 32.822,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2015",
    "ticker": "FJAUX",
    "name": "Fidelity Advisor Freedom Blend 2015 Fund - Class A",
    "pct": 32.822,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2015",
    "ticker": "FILSX",
    "name": "Fidelity Flex Freedom Blend 2015 Fund",
    "pct": 34.29,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2015",
    "ticker": "FIRSX",
    "name": "Fidelity Managed Retirement 2015 Fund",
    "pct": 38.97,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2015",
    "ticker": "FKRSX",
    "name": "Fidelity Managed Retirement 2015 Fund - Class K",
    "pct": 38.97,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2015",
    "ticker": "FRASX",
    "name": "Fidelity Advisor Managed Retirement 2015 Fund - Class I",
    "pct": 38.97,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2015",
    "ticker": "FIRUX",
    "name": "Fidelity Simplicity RMD 2015 Fund",
    "pct": 45.93,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2015",
    "ticker": "FSVNX",
    "name": "Fidelity Sustainable Target Date 2015 Fund",
    "pct": 48.664,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2015",
    "ticker": "FSVOX",
    "name": "Fidelity Advisor Sustainable Target Date 2015 Fund - Class A",
    "pct": 48.664,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2015",
    "ticker": "FSVPX",
    "name": "Fidelity Advisor Sustainable Target Date 2015 Fund - Class C",
    "pct": 48.664,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2015",
    "ticker": "FSVTX",
    "name": "Fidelity Advisor Sustainable Target Date 2015 Fund - Class M",
    "pct": 48.664,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2015",
    "ticker": "FATVX",
    "name": "Fidelity Freedom Index 2015 Fund - Premier II Class",
    "pct": 48.946,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2015",
    "ticker": "FFYPX",
    "name": "Fidelity Freedom Index 2015 Fund - Premier Class",
    "pct": 48.946,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2015",
    "ticker": "FIWFX",
    "name": "Fidelity Freedom Index 2015 Fund - Institutional Premium Class",
    "pct": 48.946,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2015",
    "ticker": "FLIFX",
    "name": "Fidelity Freedom Index 2015 Fund - Investor Class",
    "pct": 48.946,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2020",
    "ticker": "FDCFX",
    "name": "Fidelity Advisor Freedom 2020 Fund - Class C",
    "pct": 19.673,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2020",
    "ticker": "FOGLX",
    "name": "Fidelity Advisor Freedom 2020 Fund - Class K6",
    "pct": 19.673,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2020",
    "ticker": "FATKX",
    "name": "Fidelity Freedom 2020 Fund - Class K6",
    "pct": 21.104,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2020",
    "ticker": "FFFDX",
    "name": "Fidelity Freedom 2020 Fund",
    "pct": 21.104,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2020",
    "ticker": "FFBLX",
    "name": "Fidelity Freedom Blend 2020 Fund - Premier Class",
    "pct": 26.903,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2020",
    "ticker": "FHAVX",
    "name": "Fidelity Freedom Blend 2020 Fund",
    "pct": 26.903,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2020",
    "ticker": "FHCEX",
    "name": "Fidelity Freedom Blend 2020 Fund - Class K",
    "pct": 26.903,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2020",
    "ticker": "FJAIX",
    "name": "Fidelity Advisor Freedom Blend 2020 Fund - Class Z",
    "pct": 26.903,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2020",
    "ticker": "FJALX",
    "name": "Fidelity Advisor Freedom Blend 2020 Fund - Class C",
    "pct": 26.903,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2020",
    "ticker": "FJANX",
    "name": "Fidelity Advisor Freedom Blend 2020 Fund - Class M",
    "pct": 26.903,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2020",
    "ticker": "FULSX",
    "name": "Fidelity Flex Freedom Blend 2020 Fund",
    "pct": 28.63,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2020",
    "ticker": "FHRVX",
    "name": "Fidelity Managed Retirement 2020 Fund - Class K6",
    "pct": 34.014,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2020",
    "ticker": "FIIVX",
    "name": "Fidelity Advisor Managed Retirement 2020 Fund - Class I",
    "pct": 34.014,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2020",
    "ticker": "FIRVX",
    "name": "Fidelity Managed Retirement 2020 Fund",
    "pct": 34.014,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2020",
    "ticker": "FKRVX",
    "name": "Fidelity Managed Retirement 2020 Fund - Class K",
    "pct": 34.014,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2020",
    "ticker": "FSWDX",
    "name": "Fidelity Sustainable Target Date 2020 Fund",
    "pct": 42.645,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2020",
    "ticker": "FSWEX",
    "name": "Fidelity Advisor Sustainable Target Date 2020 Fund - Class A",
    "pct": 42.645,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2020",
    "ticker": "FSWMX",
    "name": "Fidelity Sustainable Target Date 2020 Fund - Class K",
    "pct": 42.645,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2020",
    "ticker": "FSWNX",
    "name": "Fidelity Sustainable Target Date 2020 Fund - Class K6",
    "pct": 42.645,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2020",
    "ticker": "FATYX",
    "name": "Fidelity Freedom Index 2020 Fund - Premier II Class",
    "pct": 42.996,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2020",
    "ticker": "FIWTX",
    "name": "Fidelity Freedom Index 2020 Fund - Institutional Premium Class",
    "pct": 42.996,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2020",
    "ticker": "FKIPX",
    "name": "Fidelity Freedom Index 2020 Fund - Premier Class",
    "pct": 42.996,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2020",
    "ticker": "FPIFX",
    "name": "Fidelity Freedom Index 2020 Fund - Investor Class",
    "pct": 42.996,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2020",
    "ticker": "FIRWX",
    "name": "Fidelity Simplicity RMD 2020 Fund",
    "pct": 49.41,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2025",
    "ticker": "FCTWX",
    "name": "Fidelity Advisor Freedom 2025 Fund - Class C",
    "pct": 15.575,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2025",
    "ticker": "FIJMX",
    "name": "Fidelity Advisor Freedom 2025 Fund - Class Z",
    "pct": 15.575,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2025",
    "ticker": "FFTWX",
    "name": "Fidelity Freedom 2025 Fund",
    "pct": 16.819,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2025",
    "ticker": "FFBNX",
    "name": "Fidelity Freedom Blend 2025 Fund - Premier Class",
    "pct": 21.563,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2025",
    "ticker": "FHAUX",
    "name": "Fidelity Freedom Blend 2025 Fund",
    "pct": 21.563,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2025",
    "ticker": "FHLDX",
    "name": "Fidelity Freedom Blend 2025 Fund - Class K6",
    "pct": 21.563,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2025",
    "ticker": "FELSX",
    "name": "Fidelity Flex Freedom Blend 2025 Fund",
    "pct": 26.25,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2025",
    "ticker": "FARFX",
    "name": "Fidelity Advisor Managed Retirement 2025 Fund - Class A",
    "pct": 30.072,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2025",
    "ticker": "FHRFX",
    "name": "Fidelity Managed Retirement 2025 Fund - Class K6",
    "pct": 30.072,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2025",
    "ticker": "FIRFX",
    "name": "Fidelity Advisor Managed Retirement 2025 Fund - Class I",
    "pct": 30.072,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2025",
    "ticker": "FIXRX",
    "name": "Fidelity Managed Retirement 2025 Fund",
    "pct": 30.072,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2025",
    "ticker": "FKRFX",
    "name": "Fidelity Managed Retirement 2025 Fund - Class K",
    "pct": 30.072,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2025",
    "ticker": "FATZX",
    "name": "Fidelity Freedom Index 2025 Fund - Premier II Class",
    "pct": 36.836,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2025",
    "ticker": "FFEDX",
    "name": "Fidelity Freedom Index 2025 Fund - Institutional Premium Class",
    "pct": 36.836,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2025",
    "ticker": "FLIPX",
    "name": "Fidelity Freedom Index 2025 Fund - Premier Class",
    "pct": 36.836,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2025",
    "ticker": "FQIFX",
    "name": "Fidelity Freedom Index 2025 Fund - Investor Class",
    "pct": 36.836,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2025",
    "ticker": "FSWOX",
    "name": "Fidelity Sustainable Target Date 2025 Fund",
    "pct": 42.272,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2025",
    "ticker": "FSWVX",
    "name": "Fidelity Advisor Sustainable Target Date 2025 Fund - Class Z",
    "pct": 42.272,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2025",
    "ticker": "FSWYX",
    "name": "Fidelity Sustainable Target Date 2025 Fund - Class K",
    "pct": 42.272,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2025",
    "ticker": "FSWZX",
    "name": "Fidelity Sustainable Target Date 2025 Fund - Class K6",
    "pct": 42.272,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2025",
    "ticker": "FMRHX",
    "name": "Fidelity Simplicity RMD 2025 Fund",
    "pct": 52.75,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2030",
    "ticker": "FFBPX",
    "name": "Fidelity Freedom Blend 2030 Fund - Premier Class",
    "pct": 16.934,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2030",
    "ticker": "FHAEX",
    "name": "Fidelity Freedom Blend 2030 Fund - Class K",
    "pct": 16.934,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2030",
    "ticker": "FHATX",
    "name": "Fidelity Freedom Blend 2030 Fund",
    "pct": 16.934,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2030",
    "ticker": "FHKDX",
    "name": "Fidelity Freedom Blend 2030 Fund - Class K6",
    "pct": 16.934,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2030",
    "ticker": "FJEFX",
    "name": "Fidelity Advisor Freedom Blend 2030 Fund - Class I",
    "pct": 16.934,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2030",
    "ticker": "FJTMX",
    "name": "Fidelity Advisor Freedom Blend 2030 Fund - Class C",
    "pct": 16.934,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2030",
    "ticker": "FVLSX",
    "name": "Fidelity Flex Freedom Blend 2030 Fund",
    "pct": 21.3,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2030",
    "ticker": "FMRAX",
    "name": "Fidelity Managed Retirement 2030 Fund",
    "pct": 26.373,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2030",
    "ticker": "FMRBX",
    "name": "Fidelity Advisor Managed Retirement 2030 Fund - Class A",
    "pct": 26.373,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2030",
    "ticker": "FMRFX",
    "name": "Fidelity Managed Retirement 2030 Fund - Class K6",
    "pct": 26.373,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2030",
    "ticker": "FAUYX",
    "name": "Fidelity Freedom Index 2030 Fund - Premier II Class",
    "pct": 29.934,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2030",
    "ticker": "FFEGX",
    "name": "Fidelity Freedom Index 2030 Fund - Institutional Premium Class",
    "pct": 29.934,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2030",
    "ticker": "FMKPX",
    "name": "Fidelity Freedom Index 2030 Fund - Premier Class",
    "pct": 29.934,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2030",
    "ticker": "FXIFX",
    "name": "Fidelity Freedom Index 2030 Fund - Investor Class",
    "pct": 29.934,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2030",
    "ticker": "FSXAX",
    "name": "Fidelity Sustainable Target Date 2030 Fund",
    "pct": 37.767,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2030",
    "ticker": "FSXCX",
    "name": "Fidelity Advisor Sustainable Target Date 2030 Fund - Class C",
    "pct": 37.767,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2030",
    "ticker": "FSXDX",
    "name": "Fidelity Advisor Sustainable Target Date 2030 Fund - Class M",
    "pct": 37.767,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2030",
    "ticker": "FSXEX",
    "name": "Fidelity Advisor Sustainable Target Date 2030 Fund - Class I",
    "pct": 37.767,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2030",
    "ticker": "FSRMX",
    "name": "Fidelity Simplicity RMD 2030 Fund",
    "pct": 55.03,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2035",
    "ticker": "FJLSX",
    "name": "Fidelity Flex Freedom Blend 2035 Fund",
    "pct": 15.57,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2035",
    "ticker": "FMRTX",
    "name": "Fidelity Managed Retirement 2035 Fund",
    "pct": 21.655,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2035",
    "ticker": "FMRUX",
    "name": "Fidelity Advisor Managed Retirement 2035 Fund - Class A",
    "pct": 21.655,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2035",
    "ticker": "FAVNX",
    "name": "Fidelity Freedom Index 2035 Fund - Premier II Class",
    "pct": 22.455,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2035",
    "ticker": "FFEZX",
    "name": "Fidelity Freedom Index 2035 Fund - Institutional Premium Class",
    "pct": 22.455,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2035",
    "ticker": "FIHFX",
    "name": "Fidelity Freedom Index 2035 Fund - Investor Class",
    "pct": 22.455,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2035",
    "ticker": "FNIPX",
    "name": "Fidelity Freedom Index 2035 Fund - Premier Class",
    "pct": 22.455,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2035",
    "ticker": "FSXKX",
    "name": "Fidelity Sustainable Target Date 2035 Fund",
    "pct": 30.051,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2035",
    "ticker": "FSXNX",
    "name": "Fidelity Advisor Sustainable Target Date 2035 Fund - Class C",
    "pct": 30.051,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2035",
    "ticker": "FSXOX",
    "name": "Fidelity Advisor Sustainable Target Date 2035 Fund - Class M",
    "pct": 30.051,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2035",
    "ticker": "FSXQX",
    "name": "Fidelity Advisor Sustainable Target Date 2035 Fund - Class I",
    "pct": 30.051,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2035",
    "ticker": "FSXUX",
    "name": "Fidelity Sustainable Target Date 2035 Fund - Class K6",
    "pct": 30.051,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2040",
    "ticker": "FAVOX",
    "name": "Fidelity Freedom Index 2040 Fund - Premier II Class",
    "pct": 15.13,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2040",
    "ticker": "FBIFX",
    "name": "Fidelity Freedom Index 2040 Fund - Investor Class",
    "pct": 15.13,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2040",
    "ticker": "FFIZX",
    "name": "Fidelity Freedom Index 2040 Fund - Institutional Premium Class",
    "pct": 15.13,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2040",
    "ticker": "FPIPX",
    "name": "Fidelity Freedom Index 2040 Fund - Premier Class",
    "pct": 15.13,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2040",
    "ticker": "FSXVX",
    "name": "Fidelity Sustainable Target Date 2040 Fund",
    "pct": 20.486,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2040",
    "ticker": "FSXZX",
    "name": "Fidelity Advisor Sustainable Target Date 2040 Fund - Class M",
    "pct": 20.486,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2040",
    "ticker": "FSYFX",
    "name": "Fidelity Sustainable Target Date 2040 Fund - Class K",
    "pct": 20.486,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date 2040",
    "ticker": "FSYGX",
    "name": "Fidelity Sustainable Target Date 2040 Fund - Class K6",
    "pct": 20.486,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date Retirement",
    "ticker": "FAFAX",
    "name": "Fidelity Advisor Freedom Retirement Fund - Class A",
    "pct": 33.032,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date Retirement",
    "ticker": "FCAFX",
    "name": "Fidelity Advisor Freedom Retirement Fund - Class C",
    "pct": 33.032,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date Retirement",
    "ticker": "FEGLX",
    "name": "Fidelity Advisor Freedom Retirement Fund - Class K6",
    "pct": 33.032,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date Retirement",
    "ticker": "FIAFX",
    "name": "Fidelity Advisor Freedom Retirement Fund - Class I",
    "pct": 33.032,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date Retirement",
    "ticker": "FIJUX",
    "name": "Fidelity Advisor Freedom Retirement Fund - Class Z",
    "pct": 33.032,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date Retirement",
    "ticker": "FTAFX",
    "name": "Fidelity Advisor Freedom Retirement Fund - Class M",
    "pct": 33.032,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date Retirement",
    "ticker": "FFFAX",
    "name": "Fidelity Freedom Retirement Fund",
    "pct": 34.335,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date Retirement",
    "ticker": "FYTKX",
    "name": "Fidelity Freedom Retirement Fund - Class K6",
    "pct": 34.335,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date Retirement",
    "ticker": "FFBCX",
    "name": "Fidelity Freedom Blend Retirement Fund - Premier Class",
    "pct": 41.802,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date Retirement",
    "ticker": "FHAJX",
    "name": "Fidelity Freedom Blend Retirement Fund - Class I",
    "pct": 41.802,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date Retirement",
    "ticker": "FHAKX",
    "name": "Fidelity Freedom Blend Retirement Fund - Class C",
    "pct": 41.802,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date Retirement",
    "ticker": "FHALX",
    "name": "Fidelity Freedom Blend Retirement Fund - Class M",
    "pct": 41.802,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date Retirement",
    "ticker": "FHAMX",
    "name": "Fidelity Freedom Blend Retirement Fund - Class A",
    "pct": 41.802,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date Retirement",
    "ticker": "FHBZX",
    "name": "Fidelity Freedom Blend Retirement Fund",
    "pct": 41.802,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date Retirement",
    "ticker": "FHRDX",
    "name": "Fidelity Freedom Blend Retirement Fund - Class K6",
    "pct": 41.802,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date Retirement",
    "ticker": "FIRMX",
    "name": "Fidelity Managed Retirement Income Fund",
    "pct": 42.816,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date Retirement",
    "ticker": "FTLSX",
    "name": "Fidelity Flex Freedom Blend Retirement Fund",
    "pct": 43.47,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date Retirement",
    "ticker": "FIRNX",
    "name": "Fidelity Simplicity RMD Income Fund",
    "pct": 47.71,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date Retirement",
    "ticker": "FAPIX",
    "name": "Fidelity Freedom Index Retirement Fund - Premier Class",
    "pct": 56.515,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date Retirement",
    "ticker": "FATQX",
    "name": "Fidelity Freedom Index Retirement Fund - Premier II Class",
    "pct": 56.515,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date Retirement",
    "ticker": "FFGZX",
    "name": "Fidelity Freedom Index Retirement Fund - Institutional Premium Class",
    "pct": 56.515,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date Retirement",
    "ticker": "FIKFX",
    "name": "Fidelity Freedom Index Retirement Fund - Investor Class",
    "pct": 56.515,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date Retirement",
    "ticker": "FSUDX",
    "name": "Fidelity Sustainable Target Date Retirement Fund",
    "pct": 56.843,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date Retirement",
    "ticker": "FSUJX",
    "name": "Fidelity Advisor Sustainable Target Date Retirement Fund - Class I",
    "pct": 56.843,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Target-Date Retirement",
    "ticker": "FSUWX",
    "name": "Fidelity Sustainable Target Date Retirement Fund - Class K6",
    "pct": 56.843,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Ultrashort Bond",
    "ticker": "FLDR",
    "name": "Fidelity Low Duration Bond Factor ETF",
    "pct": 10.68,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Ultrashort Bond",
    "ticker": "FZOLX",
    "name": "Fidelity SAI Low Duration Income Fund",
    "pct": 19.31,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Ultrashort Bond",
    "ticker": "FJTDX",
    "name": "Fidelity Flex Conservative Income Bond Fund",
    "pct": 19.72,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Ultrashort Bond",
    "ticker": "FCNVX",
    "name": "Fidelity Conservative Income Bond Fund",
    "pct": 19.74,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Ultrashort Bond",
    "ticker": "FCNQX",
    "name": "Fidelity Advisor Conservative Income Bond Fund - Class A",
    "pct": 19.741,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Ultrashort Bond",
    "ticker": "FCNWX",
    "name": "Fidelity Advisor Conservative Income Bond Fund - Class I",
    "pct": 19.741,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Ultrashort Bond",
    "ticker": "FCNYX",
    "name": "Fidelity Advisor Conservative Income Bond Fund - Class Z",
    "pct": 19.741,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Ultrashort Bond",
    "ticker": "FLDB",
    "name": "Fidelity Low Duration Bond ETF",
    "pct": 22.27,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Ultrashort Bond",
    "ticker": "FAPGX",
    "name": "Fidelity Sustainable Low Duration Bond Fund",
    "pct": 27.41,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Ultrashort Bond",
    "ticker": "FAMZX",
    "name": "Fidelity Advisor Sustainable Low Duration Bond Fund - Class A",
    "pct": 27.412,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Ultrashort Bond",
    "ticker": "FANDX",
    "name": "Fidelity Advisor Sustainable Low Duration Bond Fund - Class C",
    "pct": 27.412,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Ultrashort Bond",
    "ticker": "FAPBX",
    "name": "Fidelity Advisor Sustainable Low Duration Bond Fund - Class M",
    "pct": 27.412,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Ultrashort Bond",
    "ticker": "FAPDX",
    "name": "Fidelity Advisor Sustainable Low Duration Bond Fund - Class I",
    "pct": 27.412,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Ultrashort Bond",
    "ticker": "FAPEX",
    "name": "Fidelity Advisor Sustainable Low Duration Bond Fund - Class Z",
    "pct": 27.412,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Ultrashort Bond",
    "ticker": "FAPFX",
    "name": "Fidelity SAI Sustainable Low Duration Income Fund",
    "pct": 28.6,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Ultrashort Bond",
    "ticker": "FSLD",
    "name": "Fidelity Sustainable Low Duration Bond ETF",
    "pct": 32.12,
    "threshold": false
  },
  {
    "company": "Fidelity",
    "category": "Ultrashort Bond",
    "ticker": "FHQFX",
    "name": "Fidelity Series Treasury Bill Index Fund",
    "pct": 99.47,
    "threshold": true
  },
  {
    "company": "Fidelity",
    "category": "Moderate Allocation",
    "ticker": "FBZAX",
    "name": "Fidelity Advisor Balanced Fund - Class Z",
    "pct": 26.859,
    "threshold": false
  },
  {
    "company": "Franklin Templeton",
    "category": "Global Allocation",
    "ticker": "FFALX",
    "name": "Franklin Global Allocation Fund",
    "pct": 16.98,
    "threshold": false
  },
  {
    "company": "Franklin Templeton",
    "category": "Government Money Market",
    "ticker": "PGDXX",
    "name": "Putnam Government Money Market Fund",
    "pct": 15.55,
    "threshold": false
  },
  {
    "company": "Franklin Templeton",
    "category": "Government Money Market",
    "ticker": "SMGXX",
    "name": "Western Asset Government Reserves",
    "pct": 31.44,
    "threshold": false
  },
  {
    "company": "Franklin Templeton",
    "category": "Government Money Market",
    "ticker": "FMFXX",
    "name": "Franklin U.S. Government Money Fund",
    "pct": 72.85,
    "threshold": true
  },
  {
    "company": "Franklin Templeton",
    "category": "Government Money Market",
    "ticker": "FOBXX",
    "name": "Franklin OnChain U.S. Government Money Fund",
    "pct": 83.66,
    "threshold": true
  },
  {
    "company": "Franklin Templeton",
    "category": "Inflation-Protected Bond",
    "ticker": "WIA",
    "name": "Western Asset Inflation-Linked Income Fund",
    "pct": 77.71,
    "threshold": true
  },
  {
    "company": "Franklin Templeton",
    "category": "Inflation-Protected Bond",
    "ticker": "WIW",
    "name": "Western Asset Inflation-Linked Opportunities & Income Fund",
    "pct": 77.9,
    "threshold": true
  },
  {
    "company": "Franklin Templeton",
    "category": "Inflation-Protected Bond",
    "ticker": "WAFAX",
    "name": "Western Asset Inflation Indexed Plus Bond Fund",
    "pct": 90.14,
    "threshold": true
  },
  {
    "company": "Franklin Templeton",
    "category": "Intermediate Core Bond",
    "ticker": "WABAX",
    "name": "Western Asset Core Bond Fund",
    "pct": 12.19,
    "threshold": false
  },
  {
    "company": "Franklin Templeton",
    "category": "Intermediate Core Bond",
    "ticker": "WABF",
    "name": "Western Asset Bond ETF",
    "pct": 12.58,
    "threshold": false
  },
  {
    "company": "Franklin Templeton",
    "category": "Intermediate Core Bond",
    "ticker": "FKBAX",
    "name": "Franklin Total Return Fund",
    "pct": 14.45,
    "threshold": false
  },
  {
    "company": "Franklin Templeton",
    "category": "Intermediate Core Bond",
    "ticker": "WAADX",
    "name": "Western Asset SMASh Series Core Completion Fund",
    "pct": 16.93,
    "threshold": false
  },
  {
    "company": "Franklin Templeton",
    "category": "Intermediate Core Bond",
    "ticker": "LMSMX",
    "name": "Western Asset SMASh Series M Fund",
    "pct": 20.76,
    "threshold": false
  },
  {
    "company": "Franklin Templeton",
    "category": "Intermediate Core Bond",
    "ticker": "PCRB",
    "name": "Putnam ESG Core Bond ETF",
    "pct": 30.36,
    "threshold": false
  },
  {
    "company": "Franklin Templeton",
    "category": "Intermediate Core Bond",
    "ticker": "PTRNX",
    "name": "Putnam Core Bond Fund",
    "pct": 31.15,
    "threshold": false
  },
  {
    "company": "Franklin Templeton",
    "category": "Intermediate Core Bond",
    "ticker": "WATAX",
    "name": "Western Asset Intermediate Bond Fund",
    "pct": 32.47,
    "threshold": false
  },
  {
    "company": "Franklin Templeton",
    "category": "Intermediate Core Bond",
    "ticker": "FLCB",
    "name": "Franklin U.S. Core Bond ETF",
    "pct": 33.89,
    "threshold": false
  },
  {
    "company": "Franklin Templeton",
    "category": "Intermediate Core Bond",
    "ticker": "USFI",
    "name": "BrandywineGLOBAL U.S. Fixed Income ETF",
    "pct": 53.06,
    "threshold": false
  },
  {
    "company": "Franklin Templeton",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "FRSTX",
    "name": "Franklin Core Plus Bond Fund",
    "pct": 14.19,
    "threshold": false
  },
  {
    "company": "Franklin Templeton",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "LMECX",
    "name": "Western Asset SMASh Series Core Plus Completion Fund",
    "pct": 15.72,
    "threshold": false
  },
  {
    "company": "Franklin Templeton",
    "category": "Intermediate Government",
    "ticker": "FLGV",
    "name": "Franklin U.S. Treasury Bond ETF",
    "pct": 89.92,
    "threshold": true
  },
  {
    "company": "Franklin Templeton",
    "category": "Moderate Allocation",
    "ticker": "PGEOX",
    "name": "George Putnam Balanced Fund",
    "pct": 18.11,
    "threshold": false
  },
  {
    "company": "Franklin Templeton",
    "category": "Multisector Bond",
    "ticker": "MULT",
    "name": "Franklin Multisector Income ETF",
    "pct": 13.81,
    "threshold": false
  },
  {
    "company": "Franklin Templeton",
    "category": "Muni National Interm",
    "ticker": "PPNAX",
    "name": "Putnam Strategic Intermediate Municipal Fund",
    "pct": 12.06,
    "threshold": false
  },
  {
    "company": "Franklin Templeton",
    "category": "Muni National Interm",
    "ticker": "FTMU",
    "name": "Franklin Municipal Income ETF",
    "pct": 12.74,
    "threshold": false
  },
  {
    "company": "Franklin Templeton",
    "category": "Muni National Interm",
    "ticker": "FTCA",
    "name": "Franklin California Municipal Income ETF",
    "pct": 14.59,
    "threshold": false
  },
  {
    "company": "Franklin Templeton",
    "category": "Nontraditional Bond",
    "ticker": "WAUAX",
    "name": "Western Asset Total Return Unconstrained Fund",
    "pct": 14.38,
    "threshold": false
  },
  {
    "company": "Franklin Templeton",
    "category": "Nontraditional Bond",
    "ticker": "GOBAX",
    "name": "BrandywineGLOBAL Global Opportunities Bond Fund",
    "pct": 15.57,
    "threshold": false
  },
  {
    "company": "Franklin Templeton",
    "category": "Short Government",
    "ticker": "FISAX",
    "name": "Franklin Low Duration U.S. Govt Securities Fund",
    "pct": 14.84,
    "threshold": false
  },
  {
    "company": "Franklin Templeton",
    "category": "Short Government",
    "ticker": "FTSD",
    "name": "Franklin Short Duration U.S. Government ETF",
    "pct": 27.08,
    "threshold": false
  },
  {
    "company": "Franklin Templeton",
    "category": "Short-Term Bond",
    "ticker": "FLDAX",
    "name": "Franklin Low Duration Total Return Fund",
    "pct": 15.7,
    "threshold": false
  },
  {
    "company": "Franklin Templeton",
    "category": "Treasury Money Market",
    "ticker": "LAOXX",
    "name": "Western Asset Institutional U.S. Treasury Obligations MM Fund",
    "pct": 46.54,
    "threshold": false
  },
  {
    "company": "Franklin Templeton",
    "category": "Treasury Money Market",
    "ticker": "CIIXX",
    "name": "Western Asset Institutional U.S. Treasury Reserves",
    "pct": 97.4,
    "threshold": true
  },
  {
    "company": "Goldman Sachs",
    "category": "Commodities Broad Basket",
    "ticker": "GCMAX",
    "name": "GS Commodity Strategy Fund",
    "pct": 21.01,
    "threshold": false
  },
  {
    "company": "Goldman Sachs",
    "category": "Government Money Market",
    "ticker": "FGTXX",
    "name": "GS FS Government Fund",
    "pct": 40.51,
    "threshold": false
  },
  {
    "company": "Goldman Sachs",
    "category": "Government Money Market",
    "ticker": "FTIXX",
    "name": "GS FS Federal Instruments Fund",
    "pct": 99.06,
    "threshold": true
  },
  {
    "company": "Goldman Sachs",
    "category": "Inflation-Protected Bond",
    "ticker": "GIPAX",
    "name": "GS Inflation Protected Securities Fund",
    "pct": 98.4,
    "threshold": true
  },
  {
    "company": "Goldman Sachs",
    "category": "Inflation-Protected Bond",
    "ticker": "GTIP",
    "name": "GS Access Inflation Protected USD Bond ETF",
    "pct": 99.69,
    "threshold": true
  },
  {
    "company": "Goldman Sachs",
    "category": "Intermediate Core Bond",
    "ticker": "GSBFX",
    "name": "GS Core Fixed Income Fund",
    "pct": 25.58,
    "threshold": false
  },
  {
    "company": "Goldman Sachs",
    "category": "Intermediate Core Bond",
    "ticker": "GCOR",
    "name": "GS Core Bond ETF",
    "pct": 33.69,
    "threshold": false
  },
  {
    "company": "Goldman Sachs",
    "category": "Intermediate Core Bond",
    "ticker": "GAGG",
    "name": "GS Access U.S. Aggregate Bond ETF",
    "pct": 48.63,
    "threshold": false
  },
  {
    "company": "Goldman Sachs",
    "category": "Intermediate Government",
    "ticker": "GGOAX",
    "name": "GS Government Income Fund",
    "pct": 46.37,
    "threshold": false
  },
  {
    "company": "Goldman Sachs",
    "category": "Money Market-Taxable",
    "ticker": "MMIXX",
    "name": "GS Investor Money Market Fund",
    "pct": 16.52,
    "threshold": false
  },
  {
    "company": "Goldman Sachs",
    "category": "Money Market-Taxable",
    "ticker": "GSCXX",
    "name": "GS Stablecoin Reserves Fund",
    "pct": 53.99,
    "threshold": false
  },
  {
    "company": "Goldman Sachs",
    "category": "Multialternative",
    "ticker": "GDMAX",
    "name": "GS Absolute Return Tracker Fund",
    "pct": 11.52,
    "threshold": false
  },
  {
    "company": "Goldman Sachs",
    "category": "Multialternative",
    "ticker": "GMSAX",
    "name": "GS Multi-Strategy Alternatives Fund",
    "pct": 20.41,
    "threshold": false
  },
  {
    "company": "Goldman Sachs",
    "category": "Muni National Interm",
    "ticker": "GMUN",
    "name": "GS Municipal Income ETF",
    "pct": 42.04,
    "threshold": false
  },
  {
    "company": "Goldman Sachs",
    "category": "Nontraditional Bond",
    "ticker": "GSDTX",
    "name": "GS Dynamic Bond Fund",
    "pct": 14.37,
    "threshold": false
  },
  {
    "company": "Goldman Sachs",
    "category": "Short Government",
    "ticker": "GSSDX",
    "name": "GS Short Duration Government Fund",
    "pct": 71.79,
    "threshold": false
  },
  {
    "company": "Goldman Sachs",
    "category": "Short Government",
    "ticker": "GBIL",
    "name": "GS Access Treasury 0-1 Year ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "Goldman Sachs",
    "category": "Systematic Trend",
    "ticker": "GSAPX",
    "name": "GS Strategic Volatility Premium Fund",
    "pct": 79.92,
    "threshold": false
  },
  {
    "company": "Goldman Sachs",
    "category": "Tactical Allocation",
    "ticker": "GSACX",
    "name": "GS Tactical Tilt Overlay Fund",
    "pct": 17.24,
    "threshold": false
  },
  {
    "company": "Goldman Sachs",
    "category": "Tactical Allocation",
    "ticker": "GIPFX",
    "name": "GS Strategic Factor Allocation Fund",
    "pct": 51.1,
    "threshold": false
  },
  {
    "company": "Goldman Sachs",
    "category": "Treasury Money Market",
    "ticker": "FTOXX",
    "name": "GS FS Treasury Obligations Fund",
    "pct": 41.88,
    "threshold": false
  },
  {
    "company": "Goldman Sachs",
    "category": "Treasury Money Market",
    "ticker": "FTSXX",
    "name": "GS FS Treasury Solutions Fund",
    "pct": 72.02,
    "threshold": true
  },
  {
    "company": "Goldman Sachs",
    "category": "Treasury Money Market",
    "ticker": "FATXX",
    "name": "GS FS Treasury Instruments Fund",
    "pct": 99.24,
    "threshold": true
  },
  {
    "company": "iMGP",
    "category": "Multialternative",
    "ticker": "MASFX",
    "name": "iMGP Alternative Strategies Fund",
    "pct": 13.94,
    "threshold": false
  },
  {
    "company": "iMGP",
    "category": "Systematic Trend",
    "ticker": "DBMF",
    "name": "iMGP DBi Managed Futures Strategy ETF",
    "pct": 83.6,
    "threshold": true
  },
  {
    "company": "Invesco",
    "category": "Intermediate Core Bond",
    "ticker": "GTOC",
    "name": "Invesco Core Fixed Income ETF",
    "pct": 36.57,
    "threshold": false
  },
  {
    "company": "Invesco",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "GTO",
    "name": "Invesco Total Return Bond ETF",
    "pct": 13.78,
    "threshold": false
  },
  {
    "company": "Invesco",
    "category": "Short Government",
    "ticker": "GOVI",
    "name": "Invesco Equal Weight 0-30 Year Treasury ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "Invesco",
    "category": "Short-Term Bond",
    "ticker": "GTOS",
    "name": "Invesco Short Duration Total Return Bond ETF",
    "pct": 13.02,
    "threshold": false
  },
  {
    "company": "Invesco",
    "category": "Short-Term Inflation-Protected Bond",
    "ticker": "PBTP",
    "name": "Invesco 0-5 Yr US TIPS ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "Invesco",
    "category": "Target Maturity",
    "ticker": "TBLL",
    "name": "Invesco Short Term Treasury ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "Invesco",
    "category": "Ultrashort Bond",
    "ticker": "ISDB",
    "name": "Invesco Short Duration Total Return Bond ETF",
    "pct": 13.02,
    "threshold": false
  },
  {
    "company": "Invesco",
    "category": "Ultrashort Bond",
    "ticker": "VRIG",
    "name": "Invesco Variable Rate Investment Grade ETF",
    "pct": 21.39,
    "threshold": false
  },
  {
    "company": "iShares",
    "category": "Commodities - Other",
    "ticker": "COMT",
    "name": "iShares GSCI Commodity Dynamic Roll Strategy ETF",
    "pct": 13.2,
    "threshold": false
  },
  {
    "company": "iShares",
    "category": "Commodities - Other",
    "ticker": "TMET",
    "name": "iShares Transition-Enabling Metals ETF",
    "pct": 17.01,
    "threshold": false
  },
  {
    "company": "iShares",
    "category": "Commodities - Other",
    "ticker": "CMDY",
    "name": "iShares Bloomberg Roll Select Commodity Strategy",
    "pct": 32.48,
    "threshold": false
  },
  {
    "company": "iShares",
    "category": "Conservative Allocation",
    "ticker": "AOK",
    "name": "iShares Core 30/70 Conservative Allocation ETF",
    "pct": 23.04,
    "threshold": false
  },
  {
    "company": "iShares",
    "category": "Global Aggressive Allocation",
    "ticker": "EAOA",
    "name": "iShares ESG Aware 80/20 Aggressive Allocation ETF",
    "pct": 13.1,
    "threshold": false
  },
  {
    "company": "iShares",
    "category": "Global Conservative Allocation",
    "ticker": "EAOK",
    "name": "iShares ESG Aware 30/70 Conservative Alloc ETF",
    "pct": 32.41,
    "threshold": false
  },
  {
    "company": "iShares",
    "category": "Global Large-Stock Blend",
    "ticker": "BDYN",
    "name": "iShares Dynamic Equity Active ETF",
    "pct": 28.83,
    "threshold": false
  },
  {
    "company": "iShares",
    "category": "Global Moderate Allocation",
    "ticker": "EAOR",
    "name": "iShares ESG Aware 60/40 Balanced Allocation ETF",
    "pct": 22.03,
    "threshold": false
  },
  {
    "company": "iShares",
    "category": "Global Moderately Conservative Allocation",
    "ticker": "EAOM",
    "name": "iShares ESG Aware 40/60 Moderate Allocation ETF",
    "pct": 29.22,
    "threshold": false
  },
  {
    "company": "iShares",
    "category": "Inflation-Protected Bond",
    "ticker": "AGIH",
    "name": "iShares Inflation Hedged U.S. Aggregate Bond ETF",
    "pct": 39.76,
    "threshold": false
  },
  {
    "company": "iShares",
    "category": "Inflation-Protected Bond",
    "ticker": "ICPI",
    "name": "iShares 0 1 Year TIPS Bond ETF",
    "pct": 98.46,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Inflation-Protected Bond",
    "ticker": "TIP",
    "name": "iShares TIPS Bond ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Intermediate Core Bond",
    "ticker": "IUSB",
    "name": "iShares Core Universal USD Bond Market ETF",
    "pct": 32.49,
    "threshold": false
  },
  {
    "company": "iShares",
    "category": "Intermediate Core Bond",
    "ticker": "EAGG",
    "name": "iShares ESG Aware US Aggregate Bond ETF",
    "pct": 39.33,
    "threshold": false
  },
  {
    "company": "iShares",
    "category": "Intermediate Core Bond",
    "ticker": "AGG",
    "name": "iShares Core US Aggregate Bond ETF",
    "pct": 40.58,
    "threshold": false
  },
  {
    "company": "iShares",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "BRTR",
    "name": "IShares Total Return Active ETF",
    "pct": 13.46,
    "threshold": false
  },
  {
    "company": "iShares",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "SYSB",
    "name": "iShares Systematic Bond ETF",
    "pct": 16.96,
    "threshold": false
  },
  {
    "company": "iShares",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "IMTB",
    "name": "iShares Core 5 10 Year USD Bond ETF",
    "pct": 19.59,
    "threshold": false
  },
  {
    "company": "iShares",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "EUSB",
    "name": "iShares ESG Advanced Universal USD Bond Market ETF",
    "pct": 34.21,
    "threshold": false
  },
  {
    "company": "iShares",
    "category": "Intermediate Government",
    "ticker": "GGOV",
    "name": "iShares Global Government Bond USD Hedged Active",
    "pct": 19.77,
    "threshold": false
  },
  {
    "company": "iShares",
    "category": "Intermediate Government",
    "ticker": "TLTW",
    "name": "iShares 20+ Year Treasury Bond BuyWrite Strat ETF",
    "pct": 38.82,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Intermediate Government",
    "ticker": "GBF",
    "name": "iShares Government/Credit Bond ETF",
    "pct": 53.52,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Intermediate Government",
    "ticker": "GVI",
    "name": "iShares Intermediate Govt/Credit Bond ETF",
    "pct": 59.39,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Intermediate Government",
    "ticker": "AGZ",
    "name": "iShares Agency Bond ETF",
    "pct": 64.88,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Intermediate Government",
    "ticker": "SHV",
    "name": "iShares 0-1 Year Treasury Bond ETF",
    "pct": 89.8,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Intermediate Government",
    "ticker": "IEF",
    "name": "iShares 7-10 Year Treasury Bond ETF",
    "pct": 98.76,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Intermediate Government",
    "ticker": "TLH",
    "name": "iShares 10-20 Year Treasury Bond ETF",
    "pct": 99.41,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Intermediate Government",
    "ticker": "TLT",
    "name": "iShares 20+ Year Treasury Bond ETF",
    "pct": 99.64,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Intermediate Government",
    "ticker": "IEI",
    "name": "iShares 3-7 Year Treasury Bond ETF",
    "pct": 99.65,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Intermediate Government",
    "ticker": "GOVZ",
    "name": "PIMCO Advantage Global Govt Bd UCITS ETF GBPH Acc",
    "pct": 99.89,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Intermediate Government",
    "ticker": "GOVT",
    "name": "Goldman Sachs Gl Govt Bond Act UCITS ETF USD Acc",
    "pct": 99.9,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Large Growth",
    "ticker": "BGRO",
    "name": "IShares Large Cap Growth Active ETF",
    "pct": 13.41,
    "threshold": false
  },
  {
    "company": "iShares",
    "category": "Long-Term Bond",
    "ticker": "ILTB",
    "name": "iShares Core 10+ Year USD Bond ETF",
    "pct": 37.41,
    "threshold": false
  },
  {
    "company": "iShares",
    "category": "Moderate Allocation",
    "ticker": "AOR",
    "name": "iShares Core 60/40 Balanced Allocation ETF",
    "pct": 15.37,
    "threshold": false
  },
  {
    "company": "iShares",
    "category": "Moderate Allocation",
    "ticker": "AOM",
    "name": "iShares Core 40/60 Moderate Allocation ETF",
    "pct": 20.87,
    "threshold": false
  },
  {
    "company": "iShares",
    "category": "Money Market-Taxable",
    "ticker": "GMMF",
    "name": "iShares Government Money Market ETF",
    "pct": 56.43,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Multisector Bond",
    "ticker": "BTOT",
    "name": "iShares Total USD Fixed Income Market ETF",
    "pct": 35.66,
    "threshold": false
  },
  {
    "company": "iShares",
    "category": "Short Government",
    "ticker": "SGOV",
    "name": "iShares 0-3 Month Treasury Bond ETF",
    "pct": 95.14,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Short Government",
    "ticker": "LDRT",
    "name": "iShares iBonds 1-5 Year Treasury Ladder ETF",
    "pct": 98.3,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Short Government",
    "ticker": "TFLO",
    "name": "iShares Treasury Floating Rate Bond ETF",
    "pct": 99.21,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Short Government",
    "ticker": "SHY",
    "name": "iShares 1-3 Year Treasury Bond ETF",
    "pct": 99.71,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Short-Term Bond",
    "ticker": "ISTB",
    "name": "iShares Core 1-5 Year USD Bond ETF",
    "pct": 44.5,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Short-Term Inflation-Protected Bond",
    "ticker": "STIP",
    "name": "iShares 0-5 Year TIPS Bond ETF",
    "pct": 99.42,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Switzerland Equity",
    "ticker": "LDRI",
    "name": "iShares iBonds 1-5 Year TIPS Ladder ETF",
    "pct": 95.54,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Systematic Trend",
    "ticker": "ISMF",
    "name": "iShares Managed Futures Active ETF",
    "pct": 48.37,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Tactical Allocation",
    "ticker": "THRO",
    "name": "Ishares US Thematic Rotation Active ETF",
    "pct": 18.23,
    "threshold": false
  },
  {
    "company": "iShares",
    "category": "Target Maturity",
    "ticker": "IBDQ",
    "name": "iShares iBonds Dec 2025 Term Corporate ETF",
    "pct": 11.49,
    "threshold": false
  },
  {
    "company": "iShares",
    "category": "Target Maturity",
    "ticker": "IBIG",
    "name": "iShares iBonds Oct 2030 Term TIPS ETF",
    "pct": 92.51,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Target Maturity",
    "ticker": "IBTF",
    "name": "iShares iBonds Dec 2025 Term Treasury ETF",
    "pct": 95.96,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Target Maturity",
    "ticker": "IBTQ",
    "name": "iShares iBonds Dec 2035 Term Treasury ETF",
    "pct": 97.58,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Target Maturity",
    "ticker": "IBGB",
    "name": "iShares iBonds Dec 2045 Term Treasury ETF",
    "pct": 98.9,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Target Maturity",
    "ticker": "IBTG",
    "name": "iShares iBonds Dec 2026 Term Treasury ETF",
    "pct": 99.14,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Target Maturity",
    "ticker": "IBTK",
    "name": "iShares iBonds Dec 2030 Term Treasury ETF",
    "pct": 99.28,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Target Maturity",
    "ticker": "IBGL",
    "name": "iShares iBonds Dec 2055 Term Treasury ETF",
    "pct": 99.64,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Target Maturity",
    "ticker": "IBTL",
    "name": "iShares iBonds Dec 2031 Term Treasury ETF",
    "pct": 99.77,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Target Maturity",
    "ticker": "IBTJ",
    "name": "iShares iBonds Dec 2029 Term Treasury ETF",
    "pct": 99.82,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Target Maturity",
    "ticker": "IBTH",
    "name": "iShares iBonds Dec 2027 Term Treasury ETF",
    "pct": 99.84,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Target Maturity",
    "ticker": "IBTI",
    "name": "iShares iBonds Dec 2028 Term Treasury ETF",
    "pct": 99.85,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Target Maturity",
    "ticker": "IBIJ",
    "name": "iShares iBonds Oct 2033 Term TIPS ETF",
    "pct": 99.87,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Target Maturity",
    "ticker": "IBIC",
    "name": "iShares iBonds Oct 2026 Term TIPS ETF",
    "pct": 99.95,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Target Maturity",
    "ticker": "IBIF",
    "name": "iShares iBonds Oct 2029 Term TIPS ETF",
    "pct": 99.96,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Target Maturity",
    "ticker": "IBGA",
    "name": "iShares iBonds Dec 2044 Term Treasury ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Target Maturity",
    "ticker": "IBGK",
    "name": "iShares iBonds Dec 2054 Term Treasury ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Target Maturity",
    "ticker": "IBIB",
    "name": "iShares iBonds Oct 2025 Term TIPS ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Target Maturity",
    "ticker": "IBID",
    "name": "iShares iBonds Oct 2027 Term TIPS ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Target Maturity",
    "ticker": "IBIE",
    "name": "iShares iBonds Oct 2028 Term TIPS ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Target Maturity",
    "ticker": "IBIH",
    "name": "iShares iBonds Oct 2031 Term TIPS ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Target Maturity",
    "ticker": "IBII",
    "name": "iShares iBonds Oct 2032 Term TIPS ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Target Maturity",
    "ticker": "IBIK",
    "name": "iShares iBonds Oct 2034 Term TIPS ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Target Maturity",
    "ticker": "IBIL",
    "name": "iShares iBonds Oct 2035 Term TIPS ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Target Maturity",
    "ticker": "IBTM",
    "name": "iShares iBonds Dec 2032 Term Treasury ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Target Maturity",
    "ticker": "IBTO",
    "name": "iShares iBonds Dec 2033 Term Treasury ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Target Maturity",
    "ticker": "IBTP",
    "name": "iShares iBonds Dec 2034 Term Treasury ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "iShares",
    "category": "Target-Date 2030",
    "ticker": "ITDB",
    "name": "iShares LifePath Target Date 2030 ETF",
    "pct": 30.88,
    "threshold": false
  },
  {
    "company": "iShares",
    "category": "Target-Date 2035",
    "ticker": "ITDC",
    "name": "iShares LifePath Target Date 2035 ETF",
    "pct": 18.82,
    "threshold": false
  },
  {
    "company": "iShares",
    "category": "Target-Date 2040",
    "ticker": "ITDD",
    "name": "iShares LifePath Target Date 2040 ETF",
    "pct": 13.37,
    "threshold": false
  },
  {
    "company": "iShares",
    "category": "Target-Date Retirement",
    "ticker": "IRTR",
    "name": "iShares LifePath Retirement ETF",
    "pct": 40.92,
    "threshold": false
  },
  {
    "company": "iShares",
    "category": "Ultrashort Bond",
    "ticker": "AGRH",
    "name": "iShares Interest Rate Hedged US Aggregate Bond ETF",
    "pct": 19.1,
    "threshold": false
  },
  {
    "company": "iShares",
    "category": "Ultrashort Bond",
    "ticker": "NEAR",
    "name": "Ishares Short Duration Bond Active ETF",
    "pct": 24.97,
    "threshold": false
  },
  {
    "company": "iShares",
    "category": "Ultrashort Bond",
    "ticker": "CSHP",
    "name": "iShares Enhanced Short-Term Bond Active ETF",
    "pct": 83.67,
    "threshold": true
  },
  {
    "company": "JPMorgan",
    "category": "High Yield Muni",
    "ticker": "JMHI",
    "name": "JPMorgan High Yield Municipal ETF",
    "pct": 100,
    "threshold": false
  },
  {
    "company": "JPMorgan",
    "category": "Inflation-Protected Bond",
    "ticker": "JCPI",
    "name": "JPMorgan Inflation Managed Bond ETF",
    "pct": 36.59,
    "threshold": false
  },
  {
    "company": "JPMorgan",
    "category": "Intermediate Core Bond",
    "ticker": "BBAG",
    "name": "JPMorgan BetaBuilders US Aggregate Bond ETF",
    "pct": 41.21,
    "threshold": false
  },
  {
    "company": "JPMorgan",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "JBND",
    "name": "JPMorgan Active Bond ETF",
    "pct": 26.09,
    "threshold": false
  },
  {
    "company": "JPMorgan",
    "category": "Intermediate Government",
    "ticker": "BBTR",
    "name": "JPM BetaBuilders US Trs Bond UCITS ETF USD Acc",
    "pct": 97.78,
    "threshold": true
  },
  {
    "company": "JPMorgan",
    "category": "Intermediate Government",
    "ticker": "BBIB",
    "name": "JPMorgan BetaBuilders US Treasury Bond 3-10 Yr ETF",
    "pct": 98.84,
    "threshold": true
  },
  {
    "company": "JPMorgan",
    "category": "Moderately Conservative Allocation",
    "ticker": "JPIE",
    "name": "JPMorgan Income ETF",
    "pct": 12.4,
    "threshold": false
  },
  {
    "company": "JPMorgan",
    "category": "Money Market-Taxable",
    "ticker": "JMMF",
    "name": "JPMorgan 100% U.S. Treasury Securities MM ETF",
    "pct": 98.22,
    "threshold": true
  },
  {
    "company": "JPMorgan",
    "category": "Muni National Interm",
    "ticker": "JMSI",
    "name": "JPMorgan Sustainable Municipal Income ETF",
    "pct": 100,
    "threshold": false
  },
  {
    "company": "JPMorgan",
    "category": "Muni National Interm",
    "ticker": "JMUB",
    "name": "JPMorgan Municipal ETF",
    "pct": 100,
    "threshold": false
  },
  {
    "company": "JPMorgan",
    "category": "Muni National Short",
    "ticker": "JMST",
    "name": "JPMorgan Ultra-Short Municipal Income ETF",
    "pct": 100,
    "threshold": false
  },
  {
    "company": "JPMorgan",
    "category": "Short Government",
    "ticker": "BBSB",
    "name": "JPMorgan BetaBuilders US Treasury Bond 1-3 Yr ETF",
    "pct": 99.21,
    "threshold": true
  },
  {
    "company": "JPMorgan",
    "category": "Short-Term Bond",
    "ticker": "JSCP",
    "name": "JPMorgan Short Duration Core Plus ETF",
    "pct": 11.63,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Equity North America",
    "ticker": "EET",
    "name": "ProShares Ultra MSCI Emg Mkts",
    "pct": 24.28,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Global Large-Cap Blend Equity",
    "ticker": "XPP",
    "name": "ProShares Ultra FTSE China 50",
    "pct": 39.87,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Large Value",
    "ticker": "UCC",
    "name": "ProShares Ultra Consumer Discretionary",
    "pct": 14.63,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Multistrategy",
    "ticker": "HDG",
    "name": "ProShares Hedge Replication ETF",
    "pct": 80.28,
    "threshold": true
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Debt",
    "ticker": "TBX",
    "name": "ProShares Short 7-10 Year Treasury",
    "pct": 14.69,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Debt",
    "ticker": "PST",
    "name": "ProShares UltraShort 7-10 Year Treasury",
    "pct": 23.56,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Debt",
    "ticker": "SJB",
    "name": "ProShares Short High Yield",
    "pct": 64.95,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Debt",
    "ticker": "TBT",
    "name": "ProShares UltraShort 20+ Year Treasury",
    "pct": 76.37,
    "threshold": true
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "MYY",
    "name": "ProShares Short MidCap400",
    "pct": 13.06,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "EMTY",
    "name": "Proshares Decline Of The Retail Store ETF",
    "pct": 13.37,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "BIS",
    "name": "ProShares UltraShort Nasdaq Biotechnology",
    "pct": 13.81,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "SBB",
    "name": "ProShares Short SmallCap600",
    "pct": 16.24,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "YXI",
    "name": "ProShares Short FTSE China 50",
    "pct": 19.28,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "SMN",
    "name": "ProShares UltraShort Materials ETF",
    "pct": 20.23,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "SDD",
    "name": "ProShares UltraShort SmallCap600",
    "pct": 20.43,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "BITI",
    "name": "ProShares Short Bitcoin ETF",
    "pct": 20.45,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "SIJ",
    "name": "ProShares UltraShort Industrials",
    "pct": 21.45,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "SCC",
    "name": "ProShares UltraShort Consumer Discretionary",
    "pct": 21.52,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "EFU",
    "name": "ProShares UltraShort MSCI EAFE ETF",
    "pct": 22.41,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "REK",
    "name": "ProShares Short Real Estate",
    "pct": 22.75,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "REW",
    "name": "ProShares UltraShort Technology",
    "pct": 22.91,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "FXP",
    "name": "ProShares UltraShort FTSE China 50",
    "pct": 27.81,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "EEV",
    "name": "ProShares UltraShort MSCI Emerging Markets",
    "pct": 30.19,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "SEF",
    "name": "ProShares Short Financials ETF",
    "pct": 31.08,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "SMDD",
    "name": "ProShares UltraPro Short MidCap400",
    "pct": 31.42,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "SSG",
    "name": "ProShares UltraShort Semiconductors ETF",
    "pct": 32.32,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "SKF",
    "name": "ProShares UltraShort Financials ETF",
    "pct": 32.51,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "DXD",
    "name": "ProShares UltraShort Dow30",
    "pct": 32.73,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "EUM",
    "name": "ProShares Short MSCI Emerging Markets ETF",
    "pct": 33.86,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "EFZ",
    "name": "ProShares Short MSCI EAFE",
    "pct": 35.76,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "BZQ",
    "name": "ProShares UltraShort MSCI Brazil Capped",
    "pct": 39.42,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "TWM",
    "name": "ProShares UltraShort Russell2000 ETF",
    "pct": 41.32,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "SRS",
    "name": "ProShares UltraShort Real Estate ETF",
    "pct": 41.39,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "DUG",
    "name": "ProShares UltraShort Energy ETF",
    "pct": 43.91,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "EPV",
    "name": "ProShares UltraShort FTSE Europe ETF",
    "pct": 47.51,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "RWM",
    "name": "ProShares Short Russell2000",
    "pct": 61.37,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "DOG",
    "name": "ProShares Short Dow30",
    "pct": 61.77,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "SRTY",
    "name": "ProShares UltraPro Short Russell2000",
    "pct": 64.9,
    "threshold": true
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "TBF",
    "name": "ProShares Short 20+ Yr Treasury",
    "pct": 65.96,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "SDOW",
    "name": "ProShares UltraPro Short Dow30 ETF",
    "pct": 74.73,
    "threshold": true
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "QID",
    "name": "ProShares UltraShort QQQ",
    "pct": 77.08,
    "threshold": true
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "PSQ",
    "name": "ProShares Short QQQ",
    "pct": 77.43,
    "threshold": true
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "SDS",
    "name": "ProShares UltraShort S&P500",
    "pct": 82.3,
    "threshold": true
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "SPXU",
    "name": "ProShares UltraPro Short S&P500",
    "pct": 86.73,
    "threshold": true
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "SH",
    "name": "ProShares Short S&P500 ETF",
    "pct": 86.85,
    "threshold": true
  },
  {
    "company": "ProShares",
    "category": "Trading--Inverse Equity",
    "ticker": "SQQQ",
    "name": "ProShares UltraPro Short QQQ",
    "pct": 90.05,
    "threshold": true
  },
  {
    "company": "ProShares",
    "category": "Trading--Leveraged Debt",
    "ticker": "UST",
    "name": "ProShares Ultra 7-10 Year Treasury",
    "pct": 21.21,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Leveraged Debt",
    "ticker": "UJB",
    "name": "ProShares Ultra High Yield",
    "pct": 29.14,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Leveraged Debt",
    "ticker": "UBT",
    "name": "ProShares Ultra 20+ Year Treasury",
    "pct": 60.62,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Leveraged Equity",
    "ticker": "EZJ",
    "name": "ProShares Ultra MSCI Japan",
    "pct": 10.49,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Leveraged Equity",
    "ticker": "UPW",
    "name": "ProShares Ultra Utilities",
    "pct": 11.09,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Leveraged Equity",
    "ticker": "SAA",
    "name": "ProShares Ultra SmallCap600",
    "pct": 11.3,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Leveraged Equity",
    "ticker": "UGE",
    "name": "ProShares Ultra Consumer Staples",
    "pct": 12.06,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Leveraged Equity",
    "ticker": "URE",
    "name": "ProShares Ultra Real Estate",
    "pct": 12.71,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Leveraged Equity",
    "ticker": "DIG",
    "name": "ProShares Ultra Energy",
    "pct": 12.99,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Leveraged Equity",
    "ticker": "EFO",
    "name": "ProShares Ultra MSCI EAFE",
    "pct": 13.97,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Leveraged Equity",
    "ticker": "RXL",
    "name": "ProShares Ultra Health Care",
    "pct": 14.38,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Leveraged Equity",
    "ticker": "DDM",
    "name": "ProShares Ultra Dow30",
    "pct": 16.14,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Leveraged Equity",
    "ticker": "UMDD",
    "name": "ProShares UltraPro MidCap400",
    "pct": 17.26,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Leveraged Equity",
    "ticker": "UPV",
    "name": "ProShares Ultra FTSE Europe",
    "pct": 22.59,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Leveraged Equity",
    "ticker": "BIB",
    "name": "ProShares Ultra Nasdaq Biotechnology",
    "pct": 29.65,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Leveraged Equity",
    "ticker": "UWM",
    "name": "ProShares Ultra Russell2000",
    "pct": 32.28,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Leveraged Equity",
    "ticker": "UBR",
    "name": "ProShares Ultra MSCI Brazil Capped ETF",
    "pct": 32.72,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Leveraged Equity",
    "ticker": "ROM",
    "name": "ProShares Ultra Technology",
    "pct": 33.91,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Leveraged Equity",
    "ticker": "SSO",
    "name": "ProShares Ultra S&P500",
    "pct": 34.74,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Leveraged Equity",
    "ticker": "UDOW",
    "name": "ProShares UltraPro Dow30",
    "pct": 36.16,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Leveraged Equity",
    "ticker": "QLD",
    "name": "ProShares Ultra QQQ",
    "pct": 38.09,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Leveraged Equity",
    "ticker": "URTY",
    "name": "ProShares UltraPro Russell2000",
    "pct": 48.52,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Leveraged Equity",
    "ticker": "UPRO",
    "name": "ProShares UltraPro S&P500",
    "pct": 51.8,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Leveraged Equity",
    "ticker": "USD",
    "name": "ProShares Ultra Semiconductors",
    "pct": 53.3,
    "threshold": false
  },
  {
    "company": "ProShares",
    "category": "Trading--Leveraged Equity",
    "ticker": "TQQQ",
    "name": "ProShares UltraPro QQQ",
    "pct": 64.58,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Conservative Allocation",
    "ticker": "SWLRX",
    "name": "Schwab Monthly Income Fund - Income Payout",
    "pct": 16.01,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Global Moderately Aggressive Allocation",
    "ticker": "SWHGX",
    "name": "Schwab MarketTrack Growth Portfolio",
    "pct": 11.58,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Global Moderately Conservative Allocation",
    "ticker": "SWJRX",
    "name": "Schwab Monthly Income Fund - Target Payout",
    "pct": 13.79,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Global Moderately Conservative Allocation",
    "ticker": "SWKRX",
    "name": "Schwab Monthly Income Fund - Flexible Payout",
    "pct": 14.17,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Government Money Market",
    "ticker": "SGUXX",
    "name": "Schwab Government Money Fund",
    "pct": 36.2,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Government Money Market",
    "ticker": "SNVXX",
    "name": "Schwab Government Money Fund",
    "pct": 36.2,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Government Money Market",
    "ticker": "SWGXX",
    "name": "Schwab Government Money Fund",
    "pct": 36.2,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Inflation-Protected Bond",
    "ticker": "SCHP",
    "name": "Schwab US TIPS ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "Schwab",
    "category": "Inflation-Protected Bond",
    "ticker": "SWRSX",
    "name": "Schwab Treasury Inflation Protected Securities Index Fund",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "Schwab",
    "category": "Intermediate Core Bond",
    "ticker": "SCCR",
    "name": "Schwab Core Bond ETF",
    "pct": 14.69,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Intermediate Core Bond",
    "ticker": "SWAGX",
    "name": "Schwab U.S. Aggregate Bond Index Fund",
    "pct": 44.06,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Intermediate Core Bond",
    "ticker": "SCHZ",
    "name": "Schwab US Aggregate Bond ETF",
    "pct": 44.18,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Long Government",
    "ticker": "SCHQ",
    "name": "Schwab Long-Term US Treasury ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "Schwab",
    "category": "Moderate Allocation",
    "ticker": "SWBGX",
    "name": "Schwab MarketTrack Balanced Portfolio",
    "pct": 22.55,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Moderate Allocation",
    "ticker": "SWOBX",
    "name": "Schwab Balanced Fund",
    "pct": 34.93,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Moderately Conservative Allocation",
    "ticker": "SWCGX",
    "name": "Schwab MarketTrack Conservative Portfolio",
    "pct": 30.94,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Money Market-Taxable",
    "ticker": "SNRXX",
    "name": "Schwab Retirement Government Money Fund",
    "pct": 35.58,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Money Market-Taxable",
    "ticker": "SGVT",
    "name": "Schwab Government Money Market ETF",
    "pct": 36.66,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Municipal Money Market",
    "ticker": "SWOXX",
    "name": "Schwab Municipal Money Fund",
    "pct": 96.41,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Municipal Money Market",
    "ticker": "SWTXX",
    "name": "Schwab Municipal Money Fund",
    "pct": 96.41,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Municipal Money Market (AMT)",
    "ticker": "SCTXX",
    "name": "Schwab AMT Tax-Free Money Fund",
    "pct": 79.52,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Municipal Money Market (AMT)",
    "ticker": "SWWXX",
    "name": "Schwab AMT Tax-Free Money Fund",
    "pct": 79.52,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Municipal Money Market (CA)",
    "ticker": "SCAXX",
    "name": "Schwab California Municipal Money Fund",
    "pct": 73.95,
    "threshold": true
  },
  {
    "company": "Schwab",
    "category": "Municipal Money Market (CA)",
    "ticker": "SWKXX",
    "name": "Schwab California Municipal Money Fund",
    "pct": 73.95,
    "threshold": true
  },
  {
    "company": "Schwab",
    "category": "Municipal Money Market (NY)",
    "ticker": "SNYXX",
    "name": "Schwab New York Municipal Money Fund",
    "pct": 24.81,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Municipal Money Market (NY)",
    "ticker": "SWYXX",
    "name": "Schwab New York Municipal Money Fund",
    "pct": 24.81,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Short-Term Bond",
    "ticker": "SWSBX",
    "name": "Schwab Short-Term Bond Index Fund",
    "pct": 67.97,
    "threshold": true
  },
  {
    "company": "Schwab",
    "category": "Target Maturity",
    "ticker": "SCHO",
    "name": "Schwab Short Term US Treasury ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "Schwab",
    "category": "Target Maturity",
    "ticker": "SCHR",
    "name": "Schwab Intermediate-Term US Treasury ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "Schwab",
    "category": "Target-Date 2000-2010",
    "ticker": "SWBRX",
    "name": "Schwab Target 2010 Fund",
    "pct": 39.16,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Target-Date 2000-2010",
    "ticker": "SWYAX",
    "name": "Schwab Target 2010 Index Fund",
    "pct": 40.37,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Target-Date 2015",
    "ticker": "SWGRX",
    "name": "Schwab Target 2015 Fund",
    "pct": 37.53,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Target-Date 2015",
    "ticker": "SWYBX",
    "name": "Schwab Target 2015 Index Fund",
    "pct": 38.54,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Target-Date 2020",
    "ticker": "SWCRX",
    "name": "Schwab Target 2020 Fund",
    "pct": 35.92,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Target-Date 2020",
    "ticker": "SWYLX",
    "name": "Schwab Target 2020 Index Fund",
    "pct": 40.08,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Target-Date 2025",
    "ticker": "SWHRX",
    "name": "Schwab Target 2025 Fund",
    "pct": 35.2,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Target-Date 2025",
    "ticker": "SWYDX",
    "name": "Schwab Target 2025 Index Fund",
    "pct": 38.38,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Target-Date 2030",
    "ticker": "SWDRX",
    "name": "Schwab Target 2030 Fund",
    "pct": 24.36,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Target-Date 2030",
    "ticker": "SWYEX",
    "name": "Schwab Target 2030 Index Fund",
    "pct": 28.78,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Target-Date 2035",
    "ticker": "SWIRX",
    "name": "Schwab Target 2035 Fund",
    "pct": 16.75,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Target-Date 2035",
    "ticker": "SWYFX",
    "name": "Schwab Target 2035 Index Fund",
    "pct": 20.89,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Target-Date 2040",
    "ticker": "SWERX",
    "name": "Schwab Target 2040 Fund",
    "pct": 12.18,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Target-Date 2040",
    "ticker": "SWYGX",
    "name": "Schwab Target 2040 Index Fund",
    "pct": 15.51,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Target-Date 2045",
    "ticker": "SWYHX",
    "name": "Schwab Target 2045 Index Fund",
    "pct": 10.93,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Treasury Money Market",
    "ticker": "SCOXX",
    "name": "Schwab Treasury Obligations Money Fund",
    "pct": 31.3,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Treasury Money Market",
    "ticker": "SNOXX",
    "name": "Schwab Treasury Obligations Money Fund",
    "pct": 31.3,
    "threshold": false
  },
  {
    "company": "Schwab",
    "category": "Treasury Money Market",
    "ticker": "SNSXX",
    "name": "Schwab U.S. Treasury Money Fund",
    "pct": 99.99,
    "threshold": true
  },
  {
    "company": "Schwab",
    "category": "Treasury Money Market",
    "ticker": "SUTXX",
    "name": "Schwab U.S. Treasury Money Fund",
    "pct": 99.99,
    "threshold": true
  },
  {
    "company": "State Street",
    "category": "Conservative Allocation",
    "ticker": "INKM",
    "name": "SPDR SSgA Income Allocation ETF",
    "pct": 10.08,
    "threshold": false
  },
  {
    "company": "State Street",
    "category": "Global Allocation",
    "ticker": "GAL",
    "name": "SPDR SSgA Global Allocation ETF",
    "pct": 10.16,
    "threshold": false
  },
  {
    "company": "State Street",
    "category": "Inflation-Protected Bond",
    "ticker": "SPIP",
    "name": "SPDR Portfolio TIPS ETF",
    "pct": 95.85,
    "threshold": true
  },
  {
    "company": "State Street",
    "category": "Inflation-Protected Bond",
    "ticker": "TIPX",
    "name": "SPDR Bloomberg 1-10 Year TIPS ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "State Street",
    "category": "Intermediate Core Bond",
    "ticker": "FISR",
    "name": "SPDR Fixed Income Sector Rotation ETF",
    "pct": 37.56,
    "threshold": false
  },
  {
    "company": "State Street",
    "category": "Intermediate Core Bond",
    "ticker": "SPAB",
    "name": "SPDR Portfolio Aggregate Bond ETF",
    "pct": 43.67,
    "threshold": false
  },
  {
    "company": "State Street",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "TOTL",
    "name": "SPDR DoubleLine Total Return Tactical ETF",
    "pct": 16.59,
    "threshold": false
  },
  {
    "company": "State Street",
    "category": "Intermediate Government",
    "ticker": "SPTB",
    "name": "SPDR Portfolio Treasury ETF",
    "pct": 92.77,
    "threshold": true
  },
  {
    "company": "State Street",
    "category": "Intermediate Government",
    "ticker": "SPTI",
    "name": "SPDR Portfolio Intermediate Term Treasury ETF",
    "pct": 96.01,
    "threshold": true
  },
  {
    "company": "State Street",
    "category": "Long Government",
    "ticker": "SPTL",
    "name": "SPDR Portfolio Long Term Treasury ETF",
    "pct": 97.17,
    "threshold": true
  },
  {
    "company": "State Street",
    "category": "Short Government",
    "ticker": "BILS",
    "name": "SPDR Bloomberg 3-12 Month T-Bill ETF",
    "pct": 96.91,
    "threshold": true
  },
  {
    "company": "State Street",
    "category": "Short Government",
    "ticker": "SPTS",
    "name": "SPDR Portfolio Short Term Treasury ETF",
    "pct": 97.17,
    "threshold": true
  },
  {
    "company": "State Street",
    "category": "Short Government",
    "ticker": "BIL",
    "name": "SPDR Bloomberg 1-3 Month T-Bill ETF",
    "pct": 97.26,
    "threshold": true
  },
  {
    "company": "State Street",
    "category": "Short-Term Bond",
    "ticker": "PRSD",
    "name": "SPDR Short Duration IG Public & Private Credit ETF",
    "pct": 17.92,
    "threshold": false
  },
  {
    "company": "State Street",
    "category": "Short-Term Bond",
    "ticker": "STOT",
    "name": "SPDR DoubleLine Short Duration Total Return ETF",
    "pct": 23.87,
    "threshold": false
  },
  {
    "company": "State Street",
    "category": "Ultrashort Bond",
    "ticker": "ULST",
    "name": "SPDR SSGA Ultra Short Term Bond ETF",
    "pct": 27.7,
    "threshold": false
  },
  {
    "company": "State Street",
    "category": "Ultrashort Bond",
    "ticker": "SPTU",
    "name": "SPDR Portfolio Ultra Short T-Bill ETF",
    "pct": 87.05,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Commodities Broad Basket",
    "ticker": "VCMDX",
    "name": "Vanguard Commodity Strategy Fund Admiral Shares",
    "pct": 25.86,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Global Bond-USD Hedged",
    "ticker": "BNDW",
    "name": "Vanguard Total World Bond ETF",
    "pct": 21.07,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Global Conservative Allocation",
    "ticker": "VASIX",
    "name": "Vanguard LifeStrategy Income Fund Investor Shares",
    "pct": 26.32,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Global Moderate Allocation",
    "ticker": "VSMGX",
    "name": "Vanguard LifeStrategy Moderate Growth Fund Investor Shares",
    "pct": 16.28,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Global Moderately Conservative Allocation",
    "ticker": "VSCGX",
    "name": "Vanguard LifeStrategy Conservative Growth Fund Investor Shares",
    "pct": 21.29,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Inflation-Protected Bond",
    "ticker": "VAIPX",
    "name": "Vanguard Inflation-Protected Securities Fund Admiral Shares",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Inflation-Protected Bond",
    "ticker": "VIPIX",
    "name": "Vanguard Inflation-Protected Securities Fund Institutional Shares",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Inflation-Protected Bond",
    "ticker": "VIPSX",
    "name": "Vanguard Inflation-Protected Securities Fund Investor Shares",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Inflation-Protected Bond",
    "ticker": "VTP",
    "name": "Vanguard Total Inflation-Protected Securities ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Intermediate Core Bond",
    "ticker": "VCOBX",
    "name": "Vanguard Core Bond Fund Admiral Shares",
    "pct": 18.1,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Intermediate Core Bond",
    "ticker": "VCORX",
    "name": "Vanguard Core Bond Fund Investor Shares",
    "pct": 18.1,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Intermediate Core Bond",
    "ticker": "VCRB",
    "name": "Vanguard Core Bond ETF",
    "pct": 23.21,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Intermediate Core Bond",
    "ticker": "BND",
    "name": "Vanguard Total Bond Market Index Fund ETF",
    "pct": 44.06,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Intermediate Core Bond",
    "ticker": "VBMFX",
    "name": "Vanguard Total Bond Market Index Fund Investor Shares",
    "pct": 44.06,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Intermediate Core Bond",
    "ticker": "VBMPX",
    "name": "Vanguard Total Bond Market Index Fund Institutional Plus Shares",
    "pct": 44.06,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Intermediate Core Bond",
    "ticker": "VBTIX",
    "name": "Vanguard Total Bond Market Index Fund Institutional Shares",
    "pct": 44.06,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Intermediate Core Bond",
    "ticker": "VBTLX",
    "name": "Vanguard Total Bond Market Index Fund Admiral Shares",
    "pct": 44.06,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Intermediate Core Bond",
    "ticker": "VTBSX",
    "name": "Vanguard Instl Total Bond Market Index Trust",
    "pct": 44.06,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Intermediate Core Bond",
    "ticker": "VTBIX",
    "name": "Vanguard Total Bond Market II Index Fund Investor Shares",
    "pct": 45.06,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Intermediate Core Bond",
    "ticker": "VTBNX",
    "name": "Vanguard Total Bond Market II Index Fund Institutional Shares",
    "pct": 45.06,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Intermediate Core Bond",
    "ticker": "VBIIX",
    "name": "Vanguard Intermediate-Term Bond Index Fund Investor Shares",
    "pct": 51.09,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Intermediate Core Bond",
    "ticker": "VBILX",
    "name": "Vanguard Intermediate-Term Bond Index Fund Admiral Shares",
    "pct": 51.09,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Intermediate Core Bond",
    "ticker": "VBIMX",
    "name": "Vanguard Intermediate-Term Bond Index Fund Institutional Shares",
    "pct": 51.09,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Intermediate Core Bond",
    "ticker": "VBIUX",
    "name": "Vanguard Intermediate-Term Bond Index Fund Institutional Plus Shares",
    "pct": 51.09,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "VCPSX",
    "name": "Vanguard STAR Core-Plus Bond Fund Institutional Shares",
    "pct": 10.03,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "VCPAX",
    "name": "Vanguard Core-Plus Bond Fund Admiral Shares",
    "pct": 10.98,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "VCPIX",
    "name": "Vanguard Core-Plus Bond Fund Investor Shares",
    "pct": 10.98,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "VPLS",
    "name": "Vanguard Core-Plus Bond ETF",
    "pct": 15.02,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "BNDP",
    "name": "Vanguard Core-Plus Bond Index ETF",
    "pct": 40.5,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Intermediate Government",
    "ticker": "VGVT",
    "name": "Vanguard Government Securities Active ETF",
    "pct": 42.87,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Intermediate Government",
    "ticker": "VFITX",
    "name": "Vanguard Intermediate-Term Treasury Fund Investor Shares",
    "pct": 87.03,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Intermediate Government",
    "ticker": "VFIUX",
    "name": "Vanguard Intermediate-Term Treasury Fund Admiral Shares",
    "pct": 87.03,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Intermediate Government",
    "ticker": "EDV",
    "name": "Vanguard Extended Duration Treasury Index Fd ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Intermediate Government",
    "ticker": "VEDIX",
    "name": "Extended Duration Treasury Index",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Intermediate Government",
    "ticker": "VIIGX",
    "name": "Vanguard Intermediate-Term Treasury Index Fund Institutional Shares",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Intermediate Government",
    "ticker": "VSIGX",
    "name": "Vanguard Intermediate-Term Treasury Index Fund Admiral Shares",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Intermediate Government",
    "ticker": "VTG",
    "name": "Vanguard Total Treasury ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Long Government",
    "ticker": "VUSTX",
    "name": "Vanguard Long-Term Treasury Fund Investor Shares",
    "pct": 91.21,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Long Government",
    "ticker": "VUSUX",
    "name": "Vanguard Long-Term Treasury Fund Admiral Shares",
    "pct": 91.21,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Long Government",
    "ticker": "VEDTX",
    "name": "Vanguard Extended Duration Treasury Index Fund Institutional Shares",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Long Government",
    "ticker": "VLGIX",
    "name": "Vanguard Long-Term Treasury Index Fund Institutional Shares",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Long Government",
    "ticker": "VLGSX",
    "name": "Vanguard Long-Term Treasury Index Fund Admiral Shares",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Long-Term Bond",
    "ticker": "BLV",
    "name": "Vanguard Long-Term Bond Index Fund ETF",
    "pct": 45.9,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Long-Term Bond",
    "ticker": "VBLAX",
    "name": "Vanguard Long-Term Bond Index Fund Admiral Shares",
    "pct": 45.9,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Long-Term Bond",
    "ticker": "VBLIX",
    "name": "Vanguard Long-Term Bond Index Fund Institutional Plus Shares",
    "pct": 45.9,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Long-Term Bond",
    "ticker": "VBLLX",
    "name": "Vanguard Long-Term Bond Index Fund Institutional Shares",
    "pct": 45.9,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Mexico Equity",
    "ticker": "BIV",
    "name": "Vanguard Intermediate-Term Bond Index Fund ETF",
    "pct": 51.09,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Moderate Allocation",
    "ticker": "VBAIX",
    "name": "Vanguard Balanced Index Fund Institutional Shares",
    "pct": 26.54,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Moderate Allocation",
    "ticker": "VBIAX",
    "name": "Vanguard Balanced Index Fund Admiral Shares",
    "pct": 26.54,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Moderate Allocation",
    "ticker": "VBINX",
    "name": "Vanguard Balanced Index Fund Investor Shares",
    "pct": 26.54,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Moderately Conservative Allocation",
    "ticker": "VWIAX",
    "name": "Vanguard Wellesley Income Fund Admiral Shares",
    "pct": 10.43,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Moderately Conservative Allocation",
    "ticker": "VWINX",
    "name": "Vanguard Wellesley Income Fund Investor Shares",
    "pct": 10.43,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Money Market-Taxable",
    "ticker": "VMFXX",
    "name": "Federal Money Market Fund",
    "pct": 66.61,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Money Market-Taxable",
    "ticker": "VMRXX",
    "name": "Cash Reserves Federal Money Market",
    "pct": 69.58,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Money Market-Taxable",
    "ticker": "VUSXX",
    "name": "Treasury Money Market Fund",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Short Government",
    "ticker": "VSGBX",
    "name": "Vanguard Short-Term Federal Fund Investor Shares",
    "pct": 31.89,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Short Government",
    "ticker": "VSGDX",
    "name": "Vanguard Short-Term Federal Fund Admiral Shares",
    "pct": 31.89,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Short Government",
    "ticker": "VFIRX",
    "name": "Vanguard Short-Term Treasury Fund Admiral Shares",
    "pct": 81.81,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Short Government",
    "ticker": "VFISX",
    "name": "Vanguard Short-Term Treasury Fund Investor Shares",
    "pct": 81.81,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Short Government",
    "ticker": "VBIL",
    "name": "Vanguard 0-3 Month Treasury Bill ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Short Government",
    "ticker": "VSBIX",
    "name": "Vanguard Short-Term Treasury Index Fund Institutional Shares",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Short Government",
    "ticker": "VSBSX",
    "name": "Vanguard Short-Term Treasury Index Fund Admiral Shares",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Short-Term Bond",
    "ticker": "VIITX",
    "name": "Vanguard Institutional Intermediate-Term Bond Fund Institutional Plus Shares",
    "pct": 12.88,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Short-Term Bond",
    "ticker": "VISTX",
    "name": "Vanguard Institutional Short-Term Bond Fund Institutional Plus Shares",
    "pct": 14.94,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Short-Term Bond",
    "ticker": "VSDB",
    "name": "Vanguard Short Duration Bond ETF",
    "pct": 22.04,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Short-Term Bond",
    "ticker": "BSV",
    "name": "Vanguard Short-Term Bond Index Fund ETF",
    "pct": 66.02,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Short-Term Bond",
    "ticker": "VBIPX",
    "name": "Vanguard Short-Term Bond Index Fund Institutional Plus Shares",
    "pct": 66.02,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Short-Term Bond",
    "ticker": "VBIRX",
    "name": "Vanguard Short-Term Bond Index Fund Admiral Shares",
    "pct": 66.02,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Short-Term Bond",
    "ticker": "VBISX",
    "name": "Vanguard Short-Term Bond Index Fund Investor Shares",
    "pct": 66.02,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Short-Term Bond",
    "ticker": "VBITX",
    "name": "Vanguard Short-Term Bond Index Fund Institutional Shares",
    "pct": 66.02,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Short-Term Inflation-Protected Bond",
    "ticker": "VTAPX",
    "name": "Vanguard Short-Term Inflation-Protected Securities Index Fund Admiral Shares",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Short-Term Inflation-Protected Bond",
    "ticker": "VTIP",
    "name": "Vanguard Sht-Term Inflation-Protected Sec Idx ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Short-Term Inflation-Protected Bond",
    "ticker": "VTIPX",
    "name": "Vanguard Short-Term Inflation-Protected Securities Index Fund Investor Shares",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Short-Term Inflation-Protected Bond",
    "ticker": "VTSPX",
    "name": "Vanguard Short-Term Inflation-Protected Securities Index Fund Institutional Shares",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Target Maturity",
    "ticker": "VGIT",
    "name": "Vanguard Intermediate-Term Treasury Index Fd ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Target Maturity",
    "ticker": "VGLT",
    "name": "Vanguard Long-Term Treasury Index Fund ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Target Maturity",
    "ticker": "VGSH",
    "name": "Vanguard Short-Term Treasury Index Fund ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "Vanguard",
    "category": "Target-Date 2020",
    "ticker": "VTWNX",
    "name": "Vanguard Target Retirement 2020 Fund",
    "pct": 33.35,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Target-Date 2025",
    "ticker": "VTTVX",
    "name": "Vanguard Target Retirement 2025 Fund",
    "pct": 25.27,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Target-Date 2030",
    "ticker": "VTHRX",
    "name": "Vanguard Target Retirement 2030 Fund",
    "pct": 16.18,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Target-Date 2035",
    "ticker": "VTTHX",
    "name": "Vanguard Target Retirement 2035 Fund",
    "pct": 13.29,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Target-Date 2040",
    "ticker": "VFORX",
    "name": "Vanguard Target Retirement 2040 Fund",
    "pct": 11.31,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Target-Date Retirement",
    "ticker": "VTINX",
    "name": "Vanguard Target Retirement Income Fund",
    "pct": 33.96,
    "threshold": false
  },
  {
    "company": "Vanguard",
    "category": "Trading--Inverse Debt",
    "ticker": "VGUS",
    "name": "Vanguard Ultra-Short Treasury ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "WisdomTree",
    "category": "Commodities - Other",
    "ticker": "GCC",
    "name": "WisdomTree Enhanced Commodity Strategy Fund",
    "pct": 91.45,
    "threshold": true
  },
  {
    "company": "WisdomTree",
    "category": "Commodities Broad Basket",
    "ticker": "WTIP",
    "name": "WisdomTree Inflation Plus Fund",
    "pct": 94.71,
    "threshold": true
  },
  {
    "company": "WisdomTree",
    "category": "Global Large-Stock Blend",
    "ticker": "WTPI",
    "name": "WisdomTree Equity Premium Income Fund",
    "pct": 94.81,
    "threshold": true
  },
  {
    "company": "WisdomTree",
    "category": "Intermediate Core Bond",
    "ticker": "UNIY",
    "name": "WisdomTree Voya Yield Enhanced USD Unvrsl Bd Fund",
    "pct": 24.98,
    "threshold": false
  },
  {
    "company": "WisdomTree",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "SHAG",
    "name": "WisdomTree Yield Enhanced US Sh-Tr Aggregate Bond",
    "pct": 25,
    "threshold": false
  },
  {
    "company": "WisdomTree",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "AGGY",
    "name": "WisdomTree Yield Enhanced US Aggregate Bond Fund",
    "pct": 25.52,
    "threshold": false
  },
  {
    "company": "WisdomTree",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "AGZD",
    "name": "WisdomTree Interest Rate Hdg US Aggr Bd",
    "pct": 44.35,
    "threshold": false
  },
  {
    "company": "WisdomTree",
    "category": "Intermediate Government",
    "ticker": "USIN",
    "name": "WisdomTree 7-10 Year Laddered Treasury Fund",
    "pct": 99.62,
    "threshold": true
  },
  {
    "company": "WisdomTree",
    "category": "Multistrategy",
    "ticker": "CEW",
    "name": "WisdomTree Emerging Currency Strategy Fund",
    "pct": 63.66,
    "threshold": true
  },
  {
    "company": "WisdomTree",
    "category": "Multistrategy",
    "ticker": "USDU",
    "name": "WisdomTree Bloomberg US Dollar Bullish Fund",
    "pct": 93.94,
    "threshold": true
  },
  {
    "company": "WisdomTree",
    "category": "Short Government",
    "ticker": "USSH",
    "name": "WisdomTree 1-3 Year Laddered Treasury Fund",
    "pct": 99.73,
    "threshold": true
  },
  {
    "company": "WisdomTree",
    "category": "Short Government",
    "ticker": "USFR",
    "name": "WisdomTree Floating Rate Treasury Fund",
    "pct": 99.95,
    "threshold": true
  },
  {
    "company": "WisdomTree",
    "category": "Systematic Trend",
    "ticker": "WTMF",
    "name": "WisdomTree Managed Futures Strategy Fund",
    "pct": 88.11,
    "threshold": true
  },
  {
    "company": "WisdomTree",
    "category": "Target-Date Retirement",
    "ticker": "GTR",
    "name": "WisdomTree Target Range Fund",
    "pct": 97.63,
    "threshold": true
  },
  {
    "company": "Aptus",
    "category": "Intermediate Core Bond",
    "ticker": "JUCY",
    "name": "Aptus Enhanced Yield ETF",
    "pct": 51.91,
    "threshold": false
  },
  {
    "company": "BondBloxx",
    "category": "Ultrashort Bond",
    "ticker": "XHLF",
    "name": "BondBloxx Bloomberg Six Month Target Duration US Treasury ETF",
    "pct": 99.68,
    "threshold": true
  },
  {
    "company": "BondBloxx",
    "category": "Short Government",
    "ticker": "XONE",
    "name": "BondBloxx Bloomberg One Year Target Duration US Treasury ETF",
    "pct": 99.87,
    "threshold": true
  },
  {
    "company": "BondBloxx",
    "category": "Short Government",
    "ticker": "XTWO",
    "name": "BondBloxx Bloomberg Two Year Target Duration US Treasury ETF",
    "pct": 99.78,
    "threshold": true
  },
  {
    "company": "BondBloxx",
    "category": "Short Government",
    "ticker": "XTRE",
    "name": "BondBloxx Bloomberg Three Year Target Duration US Treasury ETF",
    "pct": 99.85,
    "threshold": true
  },
  {
    "company": "BondBloxx",
    "category": "Intermediate Government",
    "ticker": "XFIV",
    "name": "BondBloxx Bloomberg Five Year Target Duration US Treasury ETF",
    "pct": 99.8,
    "threshold": true
  },
  {
    "company": "BondBloxx",
    "category": "Long Government",
    "ticker": "XSVN",
    "name": "BondBloxx Bloomberg Seven Year Target Duration US Treasury ETF",
    "pct": 99.76,
    "threshold": true
  },
  {
    "company": "BondBloxx",
    "category": "Long Government",
    "ticker": "XTEN",
    "name": "BondBloxxBloomberg Ten Year Target Duration US Treasury ETF",
    "pct": 99.77,
    "threshold": true
  },
  {
    "company": "BondBloxx",
    "category": "Long Government",
    "ticker": "XTWY",
    "name": "BondBloxx Bloomberg Twenty Year Target Duration US Treasury ETF",
    "pct": 99.79,
    "threshold": true
  },
  {
    "company": "F/m",
    "category": "Long Government",
    "ticker": "UTEN",
    "name": "F/m US Treasury 10 Year Note ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "F/m",
    "category": "Short Government",
    "ticker": "OBIL",
    "name": "F/m US Treasury 12 Month Bill ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "F/m",
    "category": "Short Government",
    "ticker": "UTWO",
    "name": "F/m US Treasury 2 Year Note ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "F/m",
    "category": "Long Government",
    "ticker": "UTWY",
    "name": "F/m US Treasury 20 Year Bond ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "F/m",
    "category": "Ultrashort Bond",
    "ticker": "TBIL",
    "name": "F/m US Treasury 3 Month Bill Fund - ETF Class Shares",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "F/m",
    "category": "Short Government",
    "ticker": "UTRE",
    "name": "F/m US Treasury 3 Year Note ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "F/m",
    "category": "Long Government",
    "ticker": "UTHY",
    "name": "F/m US Treasury 30 Year Bond ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "F/m",
    "category": "Intermediate Government",
    "ticker": "UFIV",
    "name": "F/m US Treasury 5 Year Note ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "F/m",
    "category": "Ultrashort Bond",
    "ticker": "XBIL",
    "name": "F/m US Treasury 6 Month Bill ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "F/m",
    "category": "Intermediate Government",
    "ticker": "USVN",
    "name": "F/m US Treasury 7 Year Note ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "F/m",
    "category": "Short-Term Inflation-Protected Bond",
    "ticker": "RBIL",
    "name": "F/m Ultrashort Treasury Inflation-Protected Security (TIPS) ETF",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "PIMCO",
    "category": "Short-Term Inflation-Protected Bond",
    "ticker": "STPZ",
    "name": "PIMCO 1-5 Year U.S. TIPS Index Exchange-Traded Fund",
    "pct": 99.95,
    "threshold": true
  },
  {
    "company": "PIMCO",
    "category": "Inflation-Protected Bond",
    "ticker": "LTPZ",
    "name": "PIMCO 15+ Year U.S. TIPS Index Exchange-Traded Fund",
    "pct": 99.96,
    "threshold": true
  },
  {
    "company": "PIMCO",
    "category": "Long Government",
    "ticker": "ZROZ",
    "name": "PIMCO 25+ Year Zero Coupon U.S. Treasury Index Exchange-Traded Fund",
    "pct": 99.94,
    "threshold": true
  },
  {
    "company": "PIMCO",
    "category": "Inflation-Protected Bond",
    "ticker": "TIPZ",
    "name": "PIMCO Broad U.S. TIPS Index Exchange-Traded Fund",
    "pct": 99.87,
    "threshold": true
  },
  {
    "company": "PIMCO",
    "category": "Ultrashort Bond",
    "ticker": "BILZ",
    "name": "PIMCO Ultra Short Government Active Exchange-Traded Fund",
    "pct": 100,
    "threshold": true
  },
  {
    "company": "PIMCO",
    "category": "Long Government",
    "ticker": "PEDIX",
    "name": "PIMCO Extended Duration Fund Institutional Class",
    "pct": 87.84,
    "threshold": true
  },
  {
    "company": "PIMCO",
    "category": "Long Government",
    "ticker": "PEDPX",
    "name": "PIMCO Extended Duration Fund Class I-2",
    "pct": 87.84,
    "threshold": true
  },
  {
    "company": "PIMCO",
    "category": "Inflation-Protected Bond",
    "ticker": "PRAIX",
    "name": "PIMCO Long-Term Real Return Fund Institutional Class",
    "pct": 87.02,
    "threshold": true
  },
  {
    "company": "PIMCO",
    "category": "Inflation-Protected Bond",
    "ticker": "PRTPX",
    "name": "PIMCO Long-Term Real Return Fund Class I-2",
    "pct": 87.02,
    "threshold": true
  },
  {
    "company": "PIMCO",
    "category": "Long Government",
    "ticker": "PFGAX",
    "name": "PIMCO Long-Term U.S. Government Fund Class A",
    "pct": 88.59,
    "threshold": true
  },
  {
    "company": "PIMCO",
    "category": "Long Government",
    "ticker": "PFGCX",
    "name": "PIMCO Long-Term U.S. Government Fund Class C",
    "pct": 88.59,
    "threshold": true
  },
  {
    "company": "PIMCO",
    "category": "Long Government",
    "ticker": "PGOVX",
    "name": "PIMCO Long-Term U.S. Government Fund Institutional Class",
    "pct": 88.59,
    "threshold": true
  },
  {
    "company": "PIMCO",
    "category": "Long Government",
    "ticker": "PLTPX",
    "name": "PIMCO Long-Term U.S. Government Fund Class I-2",
    "pct": 88.59,
    "threshold": true
  },
  {
    "company": "PIMCO",
    "category": "Tactical Allocation",
    "ticker": "PAAIX",
    "name": "PIMCO All Asset Fund Institutional Class",
    "pct": 11.64,
    "threshold": false
  },
  {
    "company": "PIMCO",
    "category": "Tactical Allocation",
    "ticker": "PAANX",
    "name": "PIMCO All Asset Fund Class I-3",
    "pct": 11.64,
    "threshold": false
  },
  {
    "company": "PIMCO",
    "category": "Tactical Allocation",
    "ticker": "PASAX",
    "name": "PIMCO All Asset Fund Class A",
    "pct": 11.64,
    "threshold": false
  },
  {
    "company": "PIMCO",
    "category": "Tactical Allocation",
    "ticker": "PAUPX",
    "name": "PIMCO All Asset All Authority Fund Class I-2",
    "pct": 20.50,
    "threshold": false
  },
  {
    "company": "PIMCO",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "PCEBX",
    "name": "PIMCO Climate Bond Fund Class A",
    "pct": 15.65,
    "threshold": false
  },
  {
    "company": "PIMCO",
    "category": "Intermediate Core-Plus Bond",
    "ticker": "PCEWX",
    "name": "PIMCO Climate Bond Fund Class I-3",
    "pct": 15.65,
    "threshold": false
  },
  {
    "company": "DFA",
    "category": "Inflation-Protected Bond",
    "ticker": "DRXIX",
    "name": "DFA LTIP Portfolio Institutional Class",
    "pct": 100.00,
    "threshold": true
  },
  {
    "company": "DFA",
    "category": "Inflation-Protected Bond",
    "ticker": "DIPSX",
    "name": "DFA Inflation-Protected Securities Portfolio Institutional Class",
    "pct": 99.99,
    "threshold": true
  },
  {
    "company": "DFA",
    "category": "Short Government",
    "ticker": "DFIGX",
    "name": "DFA Intermediate Government Fixed Income Portfolio Institutional Class",
    "pct": 99.99,
    "threshold": true
  },
  {
    "company": "DFA",
    "category": "Short Government",
    "ticker": "DFYGX",
    "name": "DFA Two-Year Government Portfolio Institutional Class",
    "pct": 99.98,
    "threshold": true
  },
  {
    "company": "DFA",
    "category": "Short Government",
    "ticker": "DFFGX",
    "name": "DFA Short-Term Government Portfolio Institutional Class",
    "pct": 99.97,
    "threshold": true
  },
  {
    "company": "DFA",
    "category": "Intermediate Core Bond",
    "ticker": "DFXIX",
    "name": "DFA Diversified Fixed Income Portfolio Institutional Class",
    "pct": 72.94,
    "threshold": true
  },
  {
    "company": "DFA",
    "category": "Short-Term Bond",
    "ticker": "DFAPX",
    "name": "DFA Investment Grade Portfolio Institutional Class Shares",
    "pct": 40.95,
    "threshold": false
  },
  {
    "company": "DFA",
    "category": "Ultrashort Bond",
    "ticker": "DFIHX",
    "name": "DFA One-Year Fixed Income Portfolio Institutional Class",
    "pct": 30.66,
    "threshold": false
  },
  {
    "company": "DFA",
    "category": "World Bond",
    "ticker": "DFGFX",
    "name": "DFA Two Year Global Fixed Income Portfolio Institutional Class",
    "pct": 14.99,
    "threshold": false
  },
  {
    "company": "DFA",
    "category": "Ultrashort Bond",
    "ticker": "DFCFX",
    "name": "DFA Two-Year Fixed Income Portfolio Institutional Class",
    "pct": 11.69,
    "threshold": false
  },
  {
    "company": "T. Rowe Price",
    "category": "Money Market",
    "ticker": "PRTXX",
    "name": "T. Rowe Price US Treasury Money Fund",
    "pct": 39.97,
    "threshold": false
  },
]


const fmt = (n) => (n || 0).toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2 });
const fmtPct = (n) => (n || 0).toFixed(2) + "%";

function exportTableToCSV(rows) {
  const header = ["Company", "Category", "Ticker", "Fund Name", "% Gov Income", "CA/CT/NY Threshold"];
  const lines = [
    header.join(","),
    ...rows.map((r) =>
      [`"${r.company}"`, `"${r.category}"`, r.ticker, `"${r.name}"`, fmtPct(r.pct), r.threshold ? "Yes" : "No"].join(",")
    ),
  ];
  const blob = new Blob([lines.join("\n")], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "gov-income-funds.csv";
  a.click();
  URL.revokeObjectURL(url);
}

async function exportToPDF(results, totals, stateOverride) {
  const date = new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
  const fmtD = (n) => (n || 0).toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2 });
  const fmtP = (n) => (n || 0).toFixed(2) + "%";

  // Load jsPDF from CDN
  if (!window.jspdf) {
    await new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
      s.onload = resolve; s.onerror = reject;
      document.head.appendChild(s);
    });
  }
  // Load AutoTable plugin
  if (!window.jspdf?.jsPDF?.prototype?.autoTable) {
    await new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = "https://cdnjs.cloudflare.com/ajax/libs/jspdf-autotable/3.5.29/jspdf.plugin.autotable.min.js";
      s.onload = resolve; s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  const { jsPDF } = window.jspdf;
  const doc = new jsPDF({ unit: "in", format: "letter", orientation: "portrait" });
  const M = 0.7;           // left/right margin
  const PW = 8.5;          // page width
  const CW = PW - M * 2;  // content width
  let y = 0.6;

  // ── Logo ──────────────────────────────────────────────────────────────
  doc.setFont("helvetica", "bold");
  doc.setFontSize(7.5);
  doc.setTextColor("#1a8fd1");
  doc.text("EKTAK", M, y);
  doc.setTextColor("#1a5068");
  doc.text("TOOLS", M + doc.getTextWidth("EKTAK"), y);

  y += 0.22;
  doc.setFontSize(18);
  doc.setTextColor("#0d2535");
  doc.text("State Tax Slayer", M, y);

  // top-right date block
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.setTextColor("#64748b");
  doc.text("Government Source Income Report", PW - M, 0.6, { align: "right" });
  doc.text("Tax Year 2025", PW - M, 0.76, { align: "right" });
  doc.text(`Generated ${date}`, PW - M, 0.92, { align: "right" });

  // divider
  y += 0.18;
  doc.setDrawColor("#e2e8f0");
  doc.setLineWidth(0.012);
  doc.line(M, y, PW - M, y);
  y += 0.22;

  // ── Report title ───────────────────────────────────────────────────────
  doc.setFont("helvetica", "bold");
  doc.setFontSize(13);
  doc.setTextColor("#0f172a");
  doc.text("Government Source Income Report", M, y);
  y += 0.18;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8.5);
  doc.setTextColor("#64748b");
  doc.text(`Tax Year 2025  \u2022  Generated ${date}`, M, y);
  y += 0.28;

  // ── CA/CT/NY badge ─────────────────────────────────────────────────────
  if (stateOverride) {
    doc.setFillColor("#fffbeb");
    doc.setDrawColor("#fde68a");
    doc.setLineWidth(0.008);
    doc.roundedRect(M, y, CW, 0.38, 0.04, 0.04, "FD");
    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    doc.setTextColor("#92400e");
    doc.text("CA / CT / NY rules applied:", M + 0.12, y + 0.16);
    doc.setFont("helvetica", "normal");
    doc.text("Only funds meeting the 50% threshold qualify. Others show $0.00.", M + 0.12, y + 0.30);
    y += 0.52;
  }

  // ── Section label ──────────────────────────────────────────────────────
  doc.setFont("helvetica", "bold");
  doc.setFontSize(7.5);
  doc.setTextColor("#64748b");
  doc.text("FUND-BY-FUND BREAKDOWN", M, y);
  y += 0.1;

  // ── Fund table ─────────────────────────────────────────────────────────
  doc.autoTable({
    startY: y,
    margin: { left: M, right: M },
    head: [["Ticker", "Fund Name", "Dividend Income", "Gov %", "Gov Source Income"]],
    body: results.map(r => [
      r.ticker,
      r.found ? r.fundName : "Not in database",
      fmtD(r.amount),
      r.found ? fmtP(r.pct) : "—",
      fmtD(r.govIncome)
    ]),
    styles: { fontSize: 8.5, cellPadding: 0.07, textColor: [15, 23, 42], lineColor: [226, 232, 240], lineWidth: 0.005 },
    headStyles: { fillColor: [241, 245, 249], textColor: [100, 116, 139], fontStyle: "bold", fontSize: 7.5, halign: "left" },
    columnStyles: {
      0: { fontStyle: "bold", textColor: [29, 78, 216], cellWidth: 0.72 },
      1: { cellWidth: "auto" },
      2: { halign: "right", cellWidth: 1.15 },
      3: { halign: "right", cellWidth: 0.72 },
      4: { halign: "right", fontStyle: "bold", cellWidth: 1.15 },
    },
    alternateRowStyles: { fillColor: [248, 250, 252] },
    didParseCell: (data) => {
      if (data.section !== "body") return;
      const r = results[data.row.index];
      if (!r) return;
      if (data.column.index === 4) {
        data.cell.styles.textColor = r.govIncome > 0 ? [21, 128, 61] : [148, 163, 184];
      }
      if (!r.found) {
        data.cell.styles.textColor = [220, 38, 38];
        if (data.column.index === 0) data.cell.styles.textColor = [220, 38, 38];
      }
    }
  });

  y = doc.lastAutoTable.finalY + 0.22;

  // ── Summary grid ───────────────────────────────────────────────────────
  const cellW = CW / 3;
  doc.setDrawColor("#e2e8f0");
  doc.setLineWidth(0.008);
  doc.roundedRect(M, y, CW, 0.75, 0.05, 0.05, "S");
  doc.line(M + cellW, y, M + cellW, y + 0.75);
  doc.line(M + cellW * 2, y, M + cellW * 2, y + 0.75);

  const summaryItems = [
    { label: "TOTAL DIVIDEND INCOME ENTERED", value: fmtD(totals.totalInvestment), color: [15, 23, 42] },
    { label: "TOTAL GOVERNMENT SOURCE INCOME", value: fmtD(totals.totalGovIncome), color: [21, 128, 61] },
    { label: "EFFECTIVE GOV SOURCE %", value: totals.totalInvestment > 0 ? fmtP((totals.totalGovIncome / totals.totalInvestment) * 100) : "0.00%", color: [29, 78, 216] },
  ];
  summaryItems.forEach((item, i) => {
    const x = M + i * cellW + 0.14;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(6.5);
    doc.setTextColor("#94a3b8");
    const labelLines = doc.splitTextToSize(item.label, cellW - 0.2);
    doc.text(labelLines, x, y + 0.18);
    doc.setFontSize(13);
    doc.setTextColor(...item.color);
    doc.text(item.value, x, y + 0.58);
  });
  y += 0.9;

  // ── How to use ─────────────────────────────────────────────────────────
  const lineH = 0.145;
  const howto1 = doc.splitTextToSize("Share this report and ask them to apply the government source income exclusion on your state return using the amounts in the table above.", CW - 0.3);
  const howto2 = doc.splitTextToSize('For each 1099-DIV, enter it as normal, then at the "uncommon situations" screen check "A portion of these dividends is U.S. Government interest" and enter the corresponding Gov Source Income amount from the table above.', CW - 0.3);
  const boxH = 0.28 + (2 + howto1.length + howto2.length) * lineH + 0.3;

  doc.setDrawColor("#e2e8f0");
  doc.setLineWidth(0.008);
  doc.roundedRect(M, y, CW, boxH, 0.05, 0.05, "S");

  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.setTextColor("#0f172a");
  doc.text("How to use this report", M + 0.15, y + 0.22);

  let ty = y + 0.38;
  doc.setFontSize(8.5);
  doc.setTextColor("#0f172a");

  doc.setFont("helvetica", "bold");
  doc.text("Working with a tax professional?", M + 0.15, ty);
  ty += lineH;
  doc.setFont("helvetica", "normal");
  howto1.forEach(line => { doc.text(line, M + 0.15, ty); ty += lineH; });

  ty += lineH * 0.5;
  doc.setFont("helvetica", "bold");
  doc.text("Filing in TurboTax?", M + 0.15, ty);
  ty += lineH;
  doc.setFont("helvetica", "normal");
  howto2.forEach(line => { doc.text(line, M + 0.15, ty); ty += lineH; });

  y += boxH + 0.18;

  // ── Disclosure ─────────────────────────────────────────────────────────
  doc.setDrawColor("#e2e8f0");
  doc.setLineWidth(0.008);
  doc.line(M, y, PW - M, y);
  y += 0.16;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(7);
  doc.setTextColor("#64748b");
  doc.text("IMPORTANT DISCLOSURE & LIMITATION OF LIABILITY", M, y);
  y += 0.14;

  const disc = "This report is provided for informational and illustrative purposes only. EktakTools makes no representations or warranties, express or implied, as to the accuracy, completeness, or timeliness of the government source income percentages or threshold determinations contained herein. Fund companies may issue revised or corrected figures after initial publication, and percentages are subject to change. Always verify applicable percentages directly with each fund company before preparing or filing your state tax return. This report does not constitute tax, legal, or financial advice and should not be relied upon as such. EktakTools expressly disclaims all liability for any errors, omissions, or inaccuracies in this report and for any actions taken or not taken in reliance on it. Consult a qualified tax professional for advice specific to your individual circumstances.";
  const discLines = doc.splitTextToSize(disc, CW);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(7);
  doc.setTextColor("#94a3b8");
  discLines.forEach(line => { doc.text(line, M, y); y += 0.115; });

  doc.save("gov-source-income-report.pdf");
}

function exportCalcToCSV(results, totals) {
  const header = ["Ticker", "Fund Name", "Income", "Gov %", "Gov Income"];
  const lines = [
    header.join(","),
    ...results.map((r) =>
      [r.ticker, `"${r.fundName}"`, fmt(r.amount), fmtPct(r.pct), fmt(r.govIncome)].join(",")
    ),
    "",
    ["Total Investment", "", fmt(totals.totalInvestment), "", ""].join(","),
    ["Total Gov Income", "", "", "", fmt(totals.totalGovIncome)].join(","),
    ["Effective Gov %", "", "", "", fmtPct(totals.effectivePct)].join(","),
  ];
  const blob = new Blob([lines.join("\n")], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "gov-income-calculator.csv";
  a.click();
  URL.revokeObjectURL(url);
}

// ── Design tokens ──
const c = {
  bg: "#f8fafc",
  surface: "#ffffff",
  border: "#e2e8f0",
  borderStrong: "#cbd5e1",
  text: "#0f172a",
  textMuted: "#64748b",
  textLight: "#94a3b8",
  accent: "#1d4ed8",
  accentLight: "#eff6ff",
  accentMid: "#bfdbfe",
  green: "#15803d",
  greenBg: "#f0fdf4",
  greenBorder: "#bbf7d0",
  amber: "#92400e",
  amberBg: "#fffbeb",
  amberBorder: "#fde68a",
  orange: "#c2410c",
  red: "#dc2626",
  redBg: "#fef2f2",
  shadow: "0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.04)",
};

const inputStyle = {
  background: c.surface,
  border: `1px solid ${c.borderStrong}`,
  borderRadius: 6,
  padding: "8px 11px",
  color: c.text,
  fontFamily: "inherit",
  fontSize: 13,
  outline: "none",
};

const thStyle = {
  padding: "10px 14px",
  textAlign: "left",
  cursor: "pointer",
  userSelect: "none",
  fontWeight: 600,
  fontSize: 11,
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  color: c.textMuted,
  borderBottom: `2px solid ${c.border}`,
  whiteSpace: "nowrap",
  position: "sticky",
  top: 0,
  background: "#f1f5f9",
  zIndex: 2,
};

const tdStyle = {
  padding: "9px 14px",
  borderBottom: `1px solid ${c.border}`,
  fontSize: 13,
  color: c.text,
};

const btnSecondary = {
  background: c.surface,
  border: `1px solid ${c.borderStrong}`,
  borderRadius: 6,
  padding: "8px 16px",
  color: c.textMuted,
  fontFamily: "inherit",
  fontSize: 13,
  fontWeight: 500,
  cursor: "pointer",
};

const btnPrimary = {
  background: c.accent,
  border: "none",
  borderRadius: 6,
  padding: "8px 20px",
  color: "#fff",
  fontFamily: "inherit",
  fontSize: 13,
  fontWeight: 600,
  cursor: "pointer",
};

const btnExport = {
  background: c.surface,
  border: `1px solid ${c.borderStrong}`,
  borderRadius: 6,
  padding: "7px 14px",
  color: c.textMuted,
  fontFamily: "inherit",
  fontSize: 12,
  fontWeight: 500,
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  gap: 6,
};

function PctBadge({ pct }) {
  let color, bg, border;
  if (pct >= 95) { color = c.green; bg = c.greenBg; border = c.greenBorder; }
  else if (pct >= 50) { color = c.amber; bg = c.amberBg; border = c.amberBorder; }
  else { color = c.orange; bg = "#fff7ed"; border = "#fed7aa"; }
  return (
    <span style={{ background: bg, color, border: `1px solid ${border}`, borderRadius: 4, padding: "2px 8px", fontSize: 12, fontWeight: 600, fontVariantNumeric: "tabular-nums" }}>
      {fmtPct(pct)}
    </span>
  );
}

function ThresholdBadge({ yes }) {
  if (yes) return (
    <span style={{ background: c.greenBg, color: c.green, border: `1px solid ${c.greenBorder}`, borderRadius: 4, padding: "2px 8px", fontSize: 11, fontWeight: 600 }}>Yes</span>
  );
  return <span style={{ color: c.textLight, fontSize: 12 }}>No</span>;
}

function DownloadIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 1v9M5 7l3 3 3-3M2 11v2a1 1 0 001 1h10a1 1 0 001-1v-2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export default function GovSourceIQ() {
  const [tab, setTab] = useState("table");
  const [infoOpen, setInfoOpen] = useState(false);
  const [sortCol, setSortCol] = useState("company");
  const [sortDir, setSortDir] = useState("asc");
  const [searchText, setSearchText] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [showImport, setShowImport] = useState(false);

  const [holdings, setHoldings] = useState(() => {
    const saved = localStorage.getItem("gov_explorer_holdings");
    return saved ? JSON.parse(saved) : [{ ticker: "", amount: "" }];
  });

  const [stateOverride, setStateOverride] = useState(() => {
    return localStorage.getItem("gov_explorer_state") === "true";
  });

  useEffect(() => {
    localStorage.setItem("gov_explorer_holdings", JSON.stringify(holdings));
    localStorage.setItem("gov_explorer_state", stateOverride);
  }, [holdings, stateOverride]);

  useEffect(() => {
    const t = setTimeout(() => setDebouncedSearch(searchText), 150);
    return () => clearTimeout(t);
  }, [searchText]);

  const handleSort = useCallback((col) => {
    if (sortCol === col) setSortDir((d) => (d === "asc" ? "desc" : "asc"));
    else { setSortCol(col); setSortDir("asc"); }
  }, [sortCol]);

  const sortedData = useMemo(() => {
    let data = RAW_DATA;
    if (debouncedSearch.trim()) {
      const s = debouncedSearch.toLowerCase();
      data = data.filter((d) =>
        d.ticker.toLowerCase().includes(s) ||
        d.name.toLowerCase().includes(s) ||
        d.company.toLowerCase().includes(s)
      );
    }
    return [...data].sort((a, b) => {
      const av = a[sortCol], bv = b[sortCol];
      if (typeof av === "boolean") return sortDir === "asc" ? (av ? 1 : 0) - (bv ? 1 : 0) : (bv ? 1 : 0) - (av ? 1 : 0);
      return sortDir === "asc" ? (av < bv ? -1 : av > bv ? 1 : 0) : (bv < av ? -1 : bv > av ? 1 : 0);
    });
  }, [sortCol, sortDir, debouncedSearch]);

  const calcResults = useMemo(() => {
    if (!holdings.length || !holdings.some((h) => h.ticker.trim() && h.amount)) return null;
    let totalGovIncome = 0, totalInvestment = 0;
    const results = holdings
      .filter((h) => h.ticker.trim())
      .map((h) => {
        const t = h.ticker.trim().toUpperCase();
        const amt = parseFloat(h.amount) || 0;
        const fund = RAW_DATA.find((d) => d.ticker.toUpperCase() === t);
        const usePct = stateOverride && fund && !fund.threshold ? 0 : fund ? fund.pct : 0;
        const govIncome = (usePct / 100) * amt;
        totalGovIncome += govIncome;
        totalInvestment += amt;
        return { ticker: t, amount: amt, fundName: fund ? fund.name : "Not found", found: !!fund, pct: fund ? fund.pct : 0, govIncome };
      });
    const effectivePct = totalInvestment > 0 ? (totalGovIncome / totalInvestment) * 100 : 0;
    return { results, totalGovIncome, totalInvestment, effectivePct };
  }, [holdings, stateOverride]);

  const handleQuickImport = (text) => {
    const lines = text.split("\n");
    const newHoldings = lines
      .map((line) => {
        const tabSplit = line.split(/\t/);
        const ticker = (tabSplit[0] || "").trim().toUpperCase();
        const amountRaw = tabSplit.length > 1
          ? tabSplit[1]
          : line.replace(/^[A-Za-z0-9]+\s*/, "");
        return { ticker, amount: amountRaw.replace(/[$,\s]/g, "").replace(/[^0-9.]/g, "") };
      })
      .filter((h) => h.ticker);
    if (newHoldings.length > 0) { setHoldings(newHoldings); setShowImport(false); }
  };

  const arrow = (col) => {
    if (sortCol !== col) return <span style={{ opacity: 0.3, marginLeft: 3 }}>↕</span>;
    return <span style={{ marginLeft: 3 }}>{sortDir === "asc" ? "↑" : "↓"}</span>;
  };

  return (
    <div style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', sans-serif", background: c.bg, color: c.text, minHeight: "100vh" }}>

      {/* ── Header ── */}
      <div style={{ background: c.surface, borderBottom: `1px solid ${c.border}`, padding: "16px 28px", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 12, boxShadow: c.shadow }}>
        <div>
          <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.2em", color: c.textLight, textTransform: "uppercase", marginBottom: 3 }}>
            <span style={{ color: "#1a8fd1" }}>EKTAK</span>
            <span style={{ background: "linear-gradient(90deg, #1a5068 0%, #0d2535 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text" }}>TOOLS</span>
          </div>
          <div style={{ fontSize: 22, fontWeight: 800, letterSpacing: "-0.01em", lineHeight: 1, fontFamily: "'Arial Black', 'Franklin Gothic Medium', sans-serif", color: "#0d2535" }}>
            State Tax Slayer
          </div>
        </div>
        <button
          onClick={() => setInfoOpen((v) => !v)}
          style={{ ...btnSecondary, fontSize: 12, padding: "6px 14px", color: c.accent, borderColor: c.accentMid, background: c.accentLight }}
        >
          {infoOpen ? "Hide" : "How this works"}
        </button>
      </div>

      {/* ── Explainer ── */}
      {infoOpen && (
        <div style={{ background: c.accentLight, borderBottom: `1px solid ${c.accentMid}`, padding: "20px 28px" }}>
          <div style={{ maxWidth: 820, display: "flex", flexDirection: "column", gap: 10 }}>
            <h2 style={{ margin: 0, fontSize: 15, fontWeight: 700, color: c.accent }}>What is government source income?</h2>
            <p style={{ margin: 0, fontSize: 13, color: "#1e3a8a", lineHeight: 1.7 }}>
              When a mutual fund or ETF earns income from U.S. government obligations — Treasuries, TIPS, agency securities — that portion of the fund's dividends may be <strong>exempt from state income tax</strong> in most states. Each fund discloses what percentage of its income came from government sources for the prior tax year.
            </p>
            <p style={{ margin: 0, fontSize: 13, color: "#1e3a8a", lineHeight: 1.7 }}>
              <strong>California, Connecticut, and New York</strong> have a stricter rule: a fund must derive at least 50% of its assets from government obligations to qualify for the exclusion at all. The "CA/CT/NY Threshold" column shows whether a fund clears that bar. If it doesn't, residents of those three states get no exclusion from that fund's income.
            </p>
            <p style={{ margin: 0, fontSize: 13, color: "#1e3a8a", lineHeight: 1.7 }}>
              Use the <strong>Fund Database</strong> tab to browse and search all funds. Use the <strong>Income Calculator</strong> to enter your actual dividend amounts by fund and calculate your total qualifying government source income for the year. Your entries are saved automatically.
            </p>
          </div>
        </div>
      )}

      {/* ── Tabs ── */}
      <div style={{ display: "flex", borderBottom: `1px solid ${c.border}`, background: c.surface, paddingLeft: 20 }}>
        {[{ id: "table", label: "Fund Database" }, { id: "calc", label: "Income Calculator" }].map((t) => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            style={{ padding: "12px 20px", background: "transparent", border: "none", borderBottom: tab === t.id ? `2px solid ${c.accent}` : "2px solid transparent", color: tab === t.id ? c.accent : c.textMuted, fontFamily: "inherit", fontSize: 13, fontWeight: tab === t.id ? 600 : 500, cursor: "pointer", marginBottom: -1 }}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div style={{ padding: "20px 24px" }}>

        {/* ── Fund Database ── */}
        {tab === "table" && (
          <div>
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 16, alignItems: "center" }}>
              <input
                placeholder="Search by ticker, name, or company..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                style={{ ...inputStyle, width: 300 }}
              />
              <span style={{ fontSize: 12, color: c.textLight }}>
                {sortedData.length} fund{sortedData.length !== 1 ? "s" : ""}
              </span>
              <div style={{ marginLeft: "auto" }}>
                <button style={btnExport} onClick={() => exportTableToCSV(sortedData)}>
                  <DownloadIcon /> Export CSV
                </button>
              </div>
            </div>

            <div style={{ borderRadius: 8, border: `1px solid ${c.border}`, overflow: "hidden", maxHeight: "70vh", overflowY: "auto", boxShadow: c.shadow, background: c.surface }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th style={thStyle} onClick={() => handleSort("company")}>Company{arrow("company")}</th>
                    <th style={thStyle} onClick={() => handleSort("category")}>Category{arrow("category")}</th>
                    <th style={thStyle} onClick={() => handleSort("ticker")}>Ticker{arrow("ticker")}</th>
                    <th style={{ ...thStyle, minWidth: 220 }} onClick={() => handleSort("name")}>Fund Name{arrow("name")}</th>
                    <th style={{ ...thStyle, textAlign: "right" }} onClick={() => handleSort("pct")}>% Gov Income{arrow("pct")}</th>
                    <th style={thStyle} onClick={() => handleSort("threshold")}>CA/CT/NY{arrow("threshold")}</th>
                  </tr>
                </thead>
                <tbody>
                  {sortedData.map((f, i) => (
                    <tr key={f.ticker} style={{ background: i % 2 === 0 ? c.surface : "#f8fafc" }}>
                      <td style={{ ...tdStyle, fontSize: 12, color: c.textMuted, fontWeight: 500 }}>{f.company}</td>
                      <td style={{ ...tdStyle, fontSize: 12, color: c.textMuted }}>{f.category}</td>
                      <td style={{ ...tdStyle, fontWeight: 700, color: c.accent, letterSpacing: "0.03em" }}>{f.ticker}</td>
                      <td style={tdStyle}>{f.name}</td>
                      <td style={{ ...tdStyle, textAlign: "right" }}><PctBadge pct={f.pct} /></td>
                      <td style={tdStyle}><ThresholdBadge yes={f.threshold} /></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* ── Income Calculator ── */}
        {tab === "calc" && (
          <div style={{ maxWidth: 900 }}>
            <div style={{ background: c.surface, border: `1px solid ${c.border}`, borderRadius: 10, padding: 24, marginBottom: 20, boxShadow: c.shadow }}>
              <h2 style={{ margin: "0 0 4px", fontSize: 16, fontWeight: 700, color: c.text }}>Portfolio Government Source Income Calculator</h2>
              <p style={{ margin: "0 0 20px", fontSize: 13, color: c.textMuted, lineHeight: 1.6 }}>
                Enter each fund ticker and the total dividends you received from it during the year. Results update automatically. Your entries are saved between sessions.
              </p>

              {/* CA/CT/NY toggle */}
              <div
                style={{ background: stateOverride ? c.amberBg : "#f8fafc", border: `1px solid ${stateOverride ? c.amberBorder : c.border}`, borderRadius: 8, padding: "14px 16px", marginBottom: 20, display: "flex", alignItems: "flex-start", gap: 12, cursor: "pointer" }}
                onClick={() => setStateOverride((v) => !v)}
              >
                <input
                  type="checkbox"
                  checked={stateOverride}
                  onChange={(e) => setStateOverride(e.target.checked)}
                  style={{ marginTop: 2, accentColor: c.accent, width: 15, height: 15, cursor: "pointer" }}
                  onClick={(e) => e.stopPropagation()}
                />
                <div>
                  <div style={{ fontSize: 13, fontWeight: 600, color: stateOverride ? c.amber : c.text }}>
                    California, Connecticut, or New York resident
                  </div>
                  <div style={{ fontSize: 12, color: c.textMuted, marginTop: 3, lineHeight: 1.5 }}>
                    When checked, funds that don't meet the CA/CT/NY 50% threshold will have 0% of their income counted as qualifying. Funds that do meet the threshold use their stated percentage as normal.
                  </div>
                </div>
              </div>

              {/* Holdings rows */}
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <div style={{ display: "flex", gap: 10, marginBottom: 2 }}>
                  <span style={{ width: 140, fontSize: 11, fontWeight: 600, color: c.textLight, textTransform: "uppercase", letterSpacing: "0.06em" }}>Ticker</span>
                  <span style={{ width: 180, fontSize: 11, fontWeight: 600, color: c.textLight, textTransform: "uppercase", letterSpacing: "0.06em" }}>Dividend Income ($)</span>
                </div>
                {holdings.map((h, i) => (
                  <div key={i} style={{ display: "flex", gap: 10, alignItems: "center" }}>
                    <input
                      placeholder="e.g. VGSH"
                      value={h.ticker}
                      onChange={(e) => {
                        const n = [...holdings];
                        n[i] = { ...n[i], ticker: e.target.value.toUpperCase() };
                        setHoldings(n);
                      }}
                      style={{ ...inputStyle, width: 140, fontWeight: 700, letterSpacing: "0.04em", color: c.accent }}
                    />
                    <input
                      type="number"
                      placeholder="0.00"
                      value={h.amount}
                      onChange={(e) => {
                        const n = [...holdings];
                        n[i] = { ...n[i], amount: e.target.value };
                        setHoldings(n);
                      }}
                      style={{ ...inputStyle, width: 180 }}
                    />
                    <button
                      onClick={() => setHoldings(holdings.filter((_, idx) => idx !== i))}
                      style={{ background: "transparent", border: "none", color: c.textLight, cursor: "pointer", fontSize: 18, lineHeight: 1, padding: "4px 6px" }}
                    >×</button>
                  </div>
                ))}
              </div>

              <div style={{ display: "flex", gap: 10, marginTop: 16, alignItems: "center", flexWrap: "wrap" }}>
                <button onClick={() => setHoldings([...holdings, { ticker: "", amount: "" }])} style={btnPrimary}>+ Add Fund</button>
                <button onClick={() => setShowImport((v) => !v)} style={btnSecondary}>Quick Import</button>
                <button onClick={() => setHoldings([{ ticker: "", amount: "" }])} style={{ ...btnSecondary, marginLeft: "auto", color: c.red, borderColor: "#fecaca" }}>Clear All</button>
              </div>

              {showImport && (
                <div style={{ marginTop: 16 }}>
                  <p style={{ margin: "0 0 8px", fontSize: 12, color: c.textMuted }}>Paste two columns (ticker, amount) from Excel — tab or comma separated, one fund per line.</p>
                  <textarea
                    placeholder={"VGSH\t1234.56\nSCHO\t890.12"}
                    onChange={(e) => handleQuickImport(e.target.value)}
                    style={{ ...inputStyle, width: "100%", height: 100, resize: "vertical", fontFamily: "monospace" }}
                  />
                </div>
              )}
            </div>

            {/* Results */}
            {calcResults && (
              <div style={{ background: c.surface, border: `1px solid ${c.border}`, borderRadius: 10, overflow: "hidden", boxShadow: c.shadow }}>
                <div style={{ padding: "14px 20px", borderBottom: `1px solid ${c.border}`, display: "flex", alignItems: "center", justifyContent: "space-between", background: "#f8fafc" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <h3 style={{ margin: 0, fontSize: 14, fontWeight: 700, color: c.text }}>Results</h3>
                    {stateOverride && (
                      <span style={{ background: c.amberBg, color: c.amber, border: `1px solid ${c.amberBorder}`, borderRadius: 4, padding: "2px 8px", fontSize: 11, fontWeight: 600 }}>
                        CA/CT/NY rules active
                      </span>
                    )}
                  </div>
                  <div style={{ display: "flex", gap: 8 }}>
                    <button style={btnExport} onClick={() => exportCalcToCSV(calcResults.results, calcResults)}>
                      <DownloadIcon /> Export CSV
                    </button>
                    <button
                      style={{ ...btnExport, color: c.accent, borderColor: c.accentMid, background: c.accentLight }}
                      onClick={() => exportToPDF(calcResults.results, calcResults, stateOverride)}
                    >
                      <svg width="13" height="13" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="2" y="1" width="10" height="13" rx="1.5" stroke="currentColor" strokeWidth="1.4"/>
                        <path d="M5 5h6M5 7.5h6M5 10h4" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
                      </svg>
                      Export PDF
                    </button>
                  </div>
                </div>

                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr>
                      <th style={{ ...thStyle, position: "static" }}>Ticker</th>
                      <th style={{ ...thStyle, position: "static", minWidth: 180 }}>Fund Name</th>
                      <th style={{ ...thStyle, position: "static", textAlign: "right" }}>Income</th>
                      <th style={{ ...thStyle, position: "static", textAlign: "right" }}>Gov %</th>
                      <th style={{ ...thStyle, position: "static", textAlign: "right" }}>Gov Income</th>
                    </tr>
                  </thead>
                  <tbody>
                    {calcResults.results.map((r, i) => (
                      <tr key={i} style={{ background: !r.found ? c.redBg : i % 2 === 0 ? c.surface : "#f8fafc" }}>
                        <td style={{ ...tdStyle, fontWeight: 700, color: r.found ? c.accent : c.red }}>
                          {r.ticker}
                          {!r.found && <span style={{ fontSize: 10, display: "block", color: c.red, fontWeight: 500 }}>Not found</span>}
                        </td>
                        <td style={{ ...tdStyle, fontSize: 12, color: c.textMuted }}>{r.fundName}</td>
                        <td style={{ ...tdStyle, textAlign: "right", fontVariantNumeric: "tabular-nums" }}>{fmt(r.amount)}</td>
                        <td style={{ ...tdStyle, textAlign: "right" }}>{r.found ? <PctBadge pct={r.pct} /> : "—"}</td>
                        <td style={{ ...tdStyle, textAlign: "right", fontWeight: 600, fontVariantNumeric: "tabular-nums", color: r.govIncome > 0 ? c.green : c.textLight }}>
                          {fmt(r.govIncome)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div style={{ borderTop: `2px solid ${c.border}`, padding: "18px 24px", display: "flex", gap: 40, flexWrap: "wrap", background: "#f8fafc" }}>
                  {[
                    { label: "Total Income Entered", value: fmt(calcResults.totalInvestment), color: c.text },
                    { label: "Government Source Income", value: fmt(calcResults.totalGovIncome), color: c.green },
                    { label: "Effective Gov Source %", value: fmtPct(calcResults.effectivePct), color: c.accent },
                  ].map((stat) => (
                    <div key={stat.label}>
                      <div style={{ fontSize: 11, fontWeight: 600, color: c.textLight, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 4 }}>{stat.label}</div>
                      <div style={{ fontSize: 22, fontWeight: 700, color: stat.color, fontVariantNumeric: "tabular-nums" }}>{stat.value}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {/* ── Footer ── */}
      <div style={{ marginTop: 80, padding: "32px 24px", borderTop: `1px solid ${c.border}`, textAlign: "center", fontSize: 11, color: c.textLight }}>
        &copy; 2026 EktakTools. All Rights Reserved.
      </div>
    </div>
  );
}
